import country from './country';

export default {
  country,
  static: {
    collicareConfirmedShippingReminderEmpty: 'Nødvendige ordredetaljer mangler. Trykk på knappen "Lukk" og gå til fanen som heter "Rediger Ordre" for å skriv inn kontakt- og åpningsdetaljene for levering. Husk å lagre og bekreft levering på nytt.',
    collicareConfirmedShippingReminder: 'NB! Disse detaljene brukes for levering. Vennligst sjekk at informasjonen er korrekt før godkjenning! Hvis nødvendig kan du redigere detaljene fra fanen som heter "Rediger Ordre"',
    sharedWarehouseProduct: 'NB! Dette produktet kommer fra et delt varelager. Kun feltene under fanen "Nettbutikk" er mulig å oppdatere.',
    tripletexCreditNoteNotice: 'NB! Synkronisering til tripletex støttes bare for fullt kreditert fakturaer',
    loadingProductLines: 'Laster linjer…',
    bundleProductPreview: {
      openProductEdit: 'Åpne produktredigering',
      bundleProducts: 'Tilhørende produkter',
      title: 'Produktpakke',
      view: 'Rediger',
      table: {
        sku: 'SKU',
        name: 'Produkt',
        action: 'Handling',
      },
    },
    productBundles: {
      filters: {
        title: 'Produktpakke',
        all: 'Alle',
      },
      create: {
        title: 'Legg til produktpakke',
      },
      edit: {
        title: 'Rediger produktpakke',
      },
      index: {
        title: 'Oversikt over produktpakker',
      },
      formTabs: {
        bundleInformation: 'Bundle Information',
      },
    },
    reminderTable: {
      type: 'Type',
      freeAmount: 'Gebyrbeløp',
      dateCreated: 'Date laget',
      reminder: 'Påminnelse',
      notes: 'Notater',
      percentage: 'Prosentdel',
      fixed: 'Fikset',
      newDueDate: 'Ny forfallsdato',
    },
    sharedWarehouse: {
      notAllowed:
        'Du har ikke lov til å redigere dette siden dette er et delt lager.',
    },
    bulkProcessOrder: {
      title: 'Bulk behandling av order',
    },
    bulkProcessBill: {
      title: 'Bulk behandling av fakturaer',
      payment_date_options: {
        selectDate: 'Velg felles betalingsdato for alle fakturaer',
        dueDate: 'Sett betalingsdato til forfallsdato',
      },
    },
    bulkDestroyProducts: {
      title: 'Utvalgte produkter som skal destrueres',
      name: 'Produktnavn',
      productQty: 'Antall',
      batch: 'Parti',
      qtyToDestroy: 'Antall å destruere',
      available: 'Antall tilgjengelig',
    },
    clientInfo: {
      billAddressMissing: 'Fakturaadressen mangler! Oppdater her',
    },
    clientAddress: {
      edit: {
        title: 'Oppdatering av kundeadresse',
      },
    },
    producers: {
      add: 'Opprett produsent',
    },
    referenceSign: {
      invoice: 'FKT',
      order: 'ORD',
    },
    alertMissingDetails: {
      customerNoContactEmail: {
        message:
          'Denne kunden har ingen registrert kontakt epost. Vennligst oppdater kunden for å sende faktura.',
        linkText: 'Rediger kunde',
      },
    },
    accountAlert: {
      greetings: 'Hei',
      msgPart1: 'kontobonnementet ditt',
      msgPart2Ending:
        'vennligst se til at abonnementet blir fornyet for å ikke miste funksjoner på din konto. Vennligst ta kontakt med',
      msgPart2Ended:
        'ditt abonnement har utløpt og funksjoner på din konto kan være redusert. Vennligst ta kontakt med',
      partial: {
        willEndIn: 'ditt abonnement utløper om',
        days: 'dager',
        day: 'dag',
      },
    },
    unpaidInvoiceAlert: {
      title: 'Forfalt faktura',
      body:
        'Kundan-kontoen deres vil bli sperret dersom fakturaen ikke betales. Vennligst betal forfalt faktura, eller ta kontakt med',
    },
    bridgeHandoff: {
      handedOff:
        'Lageroperasjoner for denne organisasjonen er flyttet til Inventory App. Denne visningen er nå skrivebeskyttet — bruk Inventory App for å opprette eller endre lager, justeringer, overføringer og mottak.',
      decommissioned:
        'Lageroperasjoner for denne organisasjonen er permanent flyttet til Inventory App. Denne modulen beholdes som et skrivebeskyttet arkiv.',
      openApp: 'Åpne Inventory App',
      blockedToast:
        'Denne handlingen er flyttet til Inventory App. Bruk Inventory App for å fullføre den.',
    },
    widgets: {
      soldProduct: {
        filters: {
          last3Months: 'Siste 3 måneder',
          last6Months: 'Siste 6 måneder',
          thisYear: 'Hittil i år',
        },
      },
    },
    license: {
      licenseNumber: 'Tillatelse #',
      organizationNumber: 'Organisasjonsnummer',
      licenseType: 'Lisenstype',
      licensePermitType: 'Tillatelsesgruppe',
      validFrom: 'Gyldig fra',
      validTo: 'Gyldig til',
      add: 'Legg til lisense',
      organizationNumberRequired:
        'Du må legge til organisasjonsnummer på kunden før du kan legge til lisens',
      groups: 'Varegrupper',
    },
    releaseNote: {
      page: {
        title: 'Hva er nytt i Kundan?',
        subTitle: 'Endringslogg',
      },
      toast: {
        message:
          'Ny versjon av Kundan er ute nå! Klikk her for å bruke siste versjon :)',
      },
      modal: {
        btnNext: 'NESTE',
        btnPrev: 'TILBAKE',
        learnLink: 'Les mer',
        pageOf: 'av',
        versionRelease: 'Versjon',
      },
      close: {
        gotIt: 'Kjør på',
      },
    },
    defaultText: {
      noData: 'Ingen Data',
      client: {
        noDataMsg:
          'Vi finner ingen kunder på din konto. Men vi kan opprette en her: ',
        noDataBtn: 'Opprett kunde',
      },
      clientGroup: {
        noDataMsg:
          'Det ser ikke ut som du har opprettet noen kunde-gruppe på din konto? Skal vi lage en nå? ',
        noDataBtn: 'Opprett kunde-gruppe',
      },
      product: {
        noDataMsg:
          'Vi finner ingen produkter på din konto? Skal vi opprette et? ',
        noDataBtn: 'Opprett produkt',
      },
      productGroup: {
        noDataMsg: 'Vi finner ingen produkt-grupper. Skal vi lage en nå?',
        noDataBtn: 'Opprett produkt-grupper',
      },
      order: {
        noDataMsg:
          'Vi finner ingen ordre på din konto. Opprett din første ordre ved å klikke her: ',
        noDataBtn: 'Opprett ordre',
      },
      edi: {
        noDataMsg:
          'Vi finner ingen EDI ordre på din konto. Vennligst sjekk igjen senere.',
      },
      bill: {
        noDataMsg:
          'Vi finner ingen fakturaer på din konto. Vil du opprette en kan vi gjøre det her: ',
        noDataBtn: 'Opprett faktura',
      },
      supplier: {
        noDataMsg:
          'Du har ikke opprettet noen leverandør ennå. Vil du opprette en kan du gjøre det her: ',
        noDataBtn: 'Opprett leverandør',
      },
      warehouse: {
        noDataMsg:
          'Du har ikke opprettet noe lager ennå. Vil du opprette et lager kan du gjøre det her: ',
        noDataBtn: 'Opprett lager',
      },
      unitOfMeasure: {
        noDataMsg:
          "It looks like you have no unit of measures yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Unit of Measures',
      },
      stock: {
        noDataMsg:
          'Du har ikke opprettet noe lagertelling ennå. Vil du opprette en lagertelling kan du gjøre det her: ',
        noDataBtn: 'Opprett lagertelling',
      },
      adjustment: {
        noDataMsg:
          'Du har ikke opprettet noe lagerjustering ennå. Vil du opprette en lagerjustering kan du gjøre det her: ',
        noDataBtn: 'Opprett lagerjustering',
      },
      purchase: {
        noDataMsg:
          'Du har ikke opprettet noe innkjøp ennå. Vil du opprette et innkjøp kan du gjøre det her: ',
        noDataBtn: 'Opprett innkjøp',
      },
      transfer: {
        noDataMsg:
          'Du har ikke opprettet noe overføringer ennå. Vil du opprette en overføring kan du gjøre det her: ',
        noDataBtn: 'Opprett overføring',
      },
      productTags: {
        noDataMsg:
          'Du har ikke opprettet noen stikko ennå. Vil du opprette et innkjøp kan du gjøre det her:',
        noDataBtn: 'Opprett stikkord',
      },
      PriceFields: {
        noDataMsg:
          "It looks like you have no price field yet? Don't sweat it, we can add one right now simply by clicking here.",
        noDataBtn: 'Create New Price Field',
      },
      exciseEntry: {
        noDataMsg: 'It looks like you have no Excise entries yet',
      },
      material: {
        noDataMsg:
          'Du har ikke opprettet noen materialer ennå. Vil du opprette et kan du gjøre det her: ',
        noDataBtn: 'Legg til materiale',
      },
      batch: {
        noDataMsg:
          'Du har ikke opprettet noen batcher ennå. Vil du opprette en kan du gjøre det her: ',
        noDataBtn: 'Opprett batch',
      },
      recipe: {
        noDataMsg:
          'Du har ikke opprettet noen oppskrifter ennå. Vil du opprette en kan du gjøre det her: ',
        noDataBtn: 'Legg til oppskrift',
      },
      equipment: {
        noDataMsg:
          'Du har ikke lagt inn noe utstyr ennå. Vil du legge til et kan du gjøre det her: ',
        noDataBtn: 'Legg til utstyr',
      },
      productPackaging: {
        noDataMsg:
          'Du har ikke lagt inn noe forpakning ennå. Vil du legge til et kan du gjøre det her: ',
        noDataBtn: 'Legg til forpakning',
      },
      productBundle: {
        noDataMsg:
          'Du har ikke lagt inn noen produktpakke ennå. Vil du legge til en kan du gjøre det her: ',
        noDataBtn: 'Legg til produktpakke',
      },
    },
    module: {
      index: {
        title: 'Modul oversikt',
      },
      info: {
        description: 'Detaljer',
        name: 'Navn',
        type: 'Type',
        group: 'Gruppe',
        price: 'Pris',
      },
      warning: {
        subscribe: 'Ønsker du å abonnere på denne modulen?',
        unsubscribe: 'Ønsker du å deaktivere denne modulen?',
      },
      error: {
        vmpError:
          'Det oppstod en feil under aktivering av modulen. Sørg for å følge instruksjonene og prøv igjen.',
      },
      subscribe: {
        title: 'Abonnering',
      },
      vmp: {
        intro:
          'Før du kan begynne å bruke modulen for synkronisering av produkter med Vinmonopolet, må følgende steg gjennomføres:',
        step1: '1. Følg beskrivelsen for oppretting av API brukere her:',
        step2: '2. Legg så til følgende e-post for å gi Kundan tilgang:',
      },
      fiken: {
        intro:
          'Ved å klikke "Abonnere" vil du bli videresendt til Fiken for å autorisere integreringen.',
        fiken_company_slug: {
          label: 'Velg hvilke selskap i Fiken som skal integreres',
          placeholder: 'Velg selskap',
        },
      },
      poweroffice: {
        intro:
        'Vår PowerOffice-integrasjon tilbyr 2 typer; "Standard" og "Alternativ".<br><br>Velg "Standard" hvis du ønsker tradisjonell synkronisering av regnskapsdata ved sending av fakturaer fra Kundan. For mer info om "Alternativ" løsning, vennligst kontakt <a href="mailto:support@kundan.no">kundeservice</a> for mer veiledning.',
      },
      ehf: {
        intro: 'Ved abonnering av EHF akepteres følgende betingelser for bruk:',
        terms:
          'Sending av EHF belastes kr. 3,- pr. transaksjon. Faktureres etterskuddsvis månedlig.',
      },
      visma: {
        intro:
          'Ved å klikke på "Abonner" vil du bli videresendt til Visma eAccounting for kontoautorisasjon. Du vil bli videresendt tilbake til Kundan når autoriseringen er fullført.',
      },
    },
    exciseEntry: {
      title: 'Særavgiftsregister',
      filters: {
        label: 'Filtre',
        all: 'Vis',
        source: {
          all: 'Vis',
          order: 'Ordre',
          creditNote: 'Kreditnota',
        },
      },
      index: {
        title: 'Særavgiftsoppføringer',
      },
      allProduct: 'Alle produkter',
      table: {
        productName: 'Produkt',
        flag: 'Status',
        qty: 'Antall',
        volume: 'Volum',
        abv: 'ABV (%)',
        liter: 'Liter',
        exciseType: 'Type',
        exciseGroup: 'Avgiftsgruppe',
        exciseBasic: 'Grunnavgift',
        excisePackaging: 'Miljøavgift',
        excisableType: 'Kildetype',
        createdAt: 'Dato',
        additionalCode: 'Tilleggskode',
        exciseAdditionalCode: 'Tilleggskode',
      },
      export: 'Eksporter',
      update: {
        success: 'Oppdatering vellykket!',
      },
    },

    wooProducts: {
      attributes: {
        abv: 'ABV',
        beer_style: 'Beer Style',
        country: 'Country',
        ebu: 'EBU',
        ibu: 'IBU',
        packaging_material: 'Packaging Material',
        packaging_type: 'Packaging Type',
        producer: 'Producer',
        quantity_in_crate: 'Quantity in Crate',
        region: 'Distrikt',
        sub_region: 'Underdistrikt',
        volum: 'Volum',
        weight: 'Weight',
        free_of_alcohol: 'Alkoholfri',
        free_or_low_on_gluten: 'Glutenfri',
        sugar: 'Sugar',
        acid: 'Acid',
        fullness: 'Fullness',
        freshness: 'Freshness',
        tannins: 'Tannins',
        bitterness: 'Bitterness',
        sweetness: 'Sødme',
        colour: 'Colour',
        odour: 'Odour',
        taste: 'Taste',
        storage_potential: 'Storage Potential',
        ingredients: 'Ingredienser',
        organic: 'Organic',
        biodynamic: 'Biodynamic',
        locally_produced: 'Locally Produced',
        environmentally_smart: 'Environmentally Smart',
        kosher: 'Kosher',
        recommended_with: 'Recommended With',
      },
    },

    materials: {
      title: 'Materialer',
      filters: {
        title: 'Materialer',
        active: 'Aktive',
        deactivated: 'Deaktive',
        all: 'Vis alle',
      },
      index: {
        title: 'Materialer',
      },
      create: {
        title: 'Legg til materialer',
        success: 'Oppretting vellykket',
      },
      edit: {
        title: 'Rediger material',
        success: 'Oppdatering vellykket',
      },
      formTabs: {
        materialInformation: 'Materialinformasjon',
      },
      table: {
        id: 'ID',
        name: 'Navn',
        description: 'Beskrivelse',
      },
      types: {
        malt: 'Malt',
        hops: 'Humle',
        yeast: 'Gjær',
        sugar: 'Sukker',
        various: 'Diverse',
        packaging: 'Forpakning',
        label: 'Etikett',
        capsuleOrCork: 'Kapsel eller kork',
        cratesAndBoxes: 'Kasser og esker',
      },
      unitOfMeasures: {
        gram: 'Gram',
        kilogram: 'Kilo',
        milliliter: 'Milliliter',
        liter: 'Liter',
        piece: 'Stykk',
      },
    },

    batches: {
      title: 'Batcher',
      filters: {
        title: 'Batcher',
        notStarted: 'Ikke startet',
        upcoming: 'Planlagt',
        ongoing: 'Pågår',
        completed: 'Fullført',
        all: 'Vis alle',
      },
      index: {
        title: 'Batcher',
      },
      create: {
        title: 'Opprett batch',
        success: 'Oppretting vellykket',
      },
      edit: {
        title: 'Rediger batch',
        success: 'Oppdatering vellykket',
      },
      logs: {
        add: 'Ny loggoppføring',
      },
      view: {
        title: 'Vis batch',
        status: 'Status',
        recipe: 'Oppskrift',
        estimated: 'Estimert',
        startDate: 'Dato startet',
        endDate: 'Dato avsluttet',
        plannedStartingDate: 'Planlagt startdato',
        bestBeforeDate: 'Best før dato',
        upcomingProcedures: 'Kommende prosedyrer',
        ongoingProcedures: 'Pågående prosedyre',
        completedProcedures: 'Fullført prosedyrer',
        createBatchTransfer: 'Tappe / overfør til lager',
        startBatch: {
          title: 'Start batch',
          confirm:
            'Når du starter batchen trekkes alle råvaremengdene spesifisert i oppskriften fra material varelageret. Ønsker du å fortsette?',
          success: 'Batch startet',
          stockError:
            'Følgende materialer har ikke nok på lagre til å starte batchen',
          stockErrorOptions: {
            adjustQty: 'Juster mengde ingredienser',
            addNew: 'Legg til nye lignende ingredienser',
            purchaseOrder: 'Opprett innkjøpsordre',
            stockAdjustment: 'Opprett lagerjustering',
          },
        },
        completeBatch: {
          title: 'Fullfør batch',
          confirmButton: 'OK, fullfør batch',
          confirm:
            'Alle ingredienser spesifisert i opp oppskriften vil bli trukket fra lager. Ønsker du å fortsette?',
          success: 'Batch fullført',
          stockError:
            'Følgende ingredienser er i manko for å kunne fullføre batchen:',
          stockErrorOptions: {
            adjustQty: 'Juster mengden ingredienser',
            addNew: 'Bytt ut ingredienser',
            purchaseOrder: 'Gjør en innkjøp',
            stockAdjustment: 'Gjør en lagerjustering',
          },
        },
        deductIngredience: {
          confirmButton: 'OK',
          cancelButton: 'Utsett',
          stockError: 'Følgende ingredienser har ikke nok mengder på lager:',
          deductAll: {
            title: 'Trekk alle ingredienser',
            message: 'Ønsker du å trekke alle ingredienser fra lager?',
            button: 'Trekk alle fra lager',
            confirmButton: 'Trekk alle',
          },
        },
        startProcedure: {
          confirm:
            'All materials amounts specified in this procedure will be deducted from the material warehouse. Do you wish to continue?',
        },
      },
      formTabs: {
        batchInformation: 'Batchinformasjon',
        edit: 'Rediger',
        details: 'Detaljer',
        materials: 'Materialer',
        log: 'Logg',
      },
      statuses: {
        planned: 'Planlegg batch',
        started: 'Start ny batch',
        ongoing: 'Pågående',
        completed: 'Fullført batch',
      },
      table: {
        name: 'Navn',
        batchNumber: 'Batch nummer',
        status: 'Status',
      },
    },

    recipes: {
      title: 'Oppskrifter',
      filters: {
        title: 'Oppskrifter',
        all: 'Vis alle',
      },
      index: {
        title: 'Oppskrifter',
      },
      create: {
        title: 'Legg til oppskrift',
        success: 'Successfully Created',
      },
      edit: {
        title: 'Rediger oppskrift',
        success: 'Oppretting vellykket',
        ingrediences: 'Ingredienser',
        procedures: 'prosedyrer',
        equipment: 'Utstyr',
        addProcedure: 'Legg til prosedyre',
        editProcedure: 'Rediger prosedyre',
        step: 'Steg',
      },
      types: {
        beer: 'Øl',
        wine: 'Vin',
        cider: 'Sider',
        liquor: 'Brennevin',
        water: 'Vann',
      },
      formTabs: {
        recipeInformation: 'Oppskrift informasjon',
        ingrediencesAndProcedures: 'Ingredienser og prosedyrer',
        products: 'Produkter',
      },
    },

    recipeIngrediences: {
      index: {
        confirmDelete:
          'Dette vil slette ingrediensene i oppskriften. Vil du fortsette?',
        confirmDeleteTitle: 'Slett oppskrift ingredienser',
      },
    },

    equipments: {
      title: 'Utstyr',
      filters: {
        title: 'Utstyr',
        all: 'Vis alle',
      },
      index: {
        title: 'Utstyr',
      },
      create: {
        title: 'Legg til utstyr',
        success: 'Successfully Created',
      },
      edit: {
        title: 'Rediger utstyr',
        success: 'Oppretting vellykket',
      },
      formTabs: {
        equipmentInformation: 'Utstyr informasjon',
      },
      table: {
        name: 'Navn',
        status: 'Status',
      },
    },

    members: {
      title: 'Brukere',
      index: {
        products: 'Produkter',
        addProduct: 'Legg til produkt',
        addMember: 'Legg til bruker',
        tab: {
          members: 'Brukere',
          calendarSchedule: 'Kalenderplan',
        },
        table: {
          members: {
            firstName: 'Fornavn',
            lastName: 'Etternavn',
            email: 'Epost',
            title: 'Title',
            color: 'Farge',
            status: 'Status',
            view: 'Vis',
          },
        },
        dialog: {
          cancel: 'Avbryt',
          update: 'Oppdater',
          add: 'Legg til',
          addMember: {
            title: 'Legg til bruker',
            firstName: 'Fornavn',
            lastName: 'Etternavn',
            email: 'Epost',
          },
          addBooking: {
            showOrder: 'Vis ordre',
            title: 'Legg til avtale',
            selectProduct: 'Velg tjeneste',
            selectPractitioner: 'Velg behandler',
            selectClient: 'Velg kunde',
          },
        },
        options: {
          businessHours: 'Arbeidstimer',
          booking: 'Avtaler',
        },
        calendar: {
          today: 'I dag',
        },
      },
      show: {
        products: 'Produkter',
        addProduct: 'Legg til produkt',
        addMember: 'Add Member',
        deleteMember: 'Slett bruker',
        addHour: 'Legg til tid',
        options: {
          start: 'Start',
          end: 'Slutt',
        },
        table: {
          product: {
            name: 'Produkt',
            price: 'Pris',
            duration: 'Varighet',
          },
        },
        dialog: {
          cancel: 'Avbryt',
          delete: 'Slett',
          add: 'Legg til',
          addProduct: {
            title: 'Legg til produkt',
          },
          deleteMember: {
            title: 'Legg til avtale',
            text: 'Ønsker du å slette brukeren',
          },
          deleteMemberProduct: {
            title: 'Legg til avtale',
            text: 'Ønsker du å fjerne denne tjenesten fra valgt behandler?',
          },
        },
      },
    },

    account: {
      toggleDebugMode: 'Toggle Debug Mode',
      confirmDebugMode: 'Are you sure you want to toggle debug mode?',
      onDebugMode: 'Debug mode turned on',
      offDebugMode: 'Debug mode turned off',
      switchOrganization: 'Endre organisasjon',
      confirmSwitchOrganization: 'Ønsker du å bytte organisasjon?',
      switchingOrganizationMessage: 'Logger inn på ny konto... Vennligst vent',
    },

    home: {
      welcomeMsg: "Bli itj fart ut'n bart!",
    },

    accountSetup: {
      title: 'Opprett konto',
      termsError: 'Du må lese og akseptere våre betingelser før registrering.',
      crm: 'Customer Relationship Management(CRM)',
      invoicing: 'Order and Invoicing',
      edi: 'Electronic Data Interchange (EDI)',
      booking: 'Online Booking',
      headerMessage1: 'Your',
      headerMessage2:
        'account has been created. We sent you an email together with your password. Please let us know who you are..',
    },

    emailSetup: {
      title: 'La oss komme i gang! Hva er din epost adresse?',
      emailExistSuggestion:
        'Epost adressen er allerede i bruk. Ønsker du å logge inn i stede?',
      crm: 'Kundan System (CMR) ?',
      invoicing: 'Faktura System ?',
      edi: 'EDI system!',
      booking: 'Booking System ?',
      headerMessage1: 'Prøv vårt unike ',
      headerMessage2: 'Fyll inn din info, og du er straks i gang!',
      termsError: 'Du må lese våre betingelser før registrering.',
    },

    personalInfo: {
      title: 'Personlig informasjon.',
    },

    registerDone: {
      title: 'Vellykket registrering!',
      firstParagraph: 'Din konto er opprettet.',
      secondParagraph1:
        'Gratulerer, du er nå registrert for 14 dagers prøveperiode. En epost med bekreftelseslink er sendt til deg. Om du ikke mottar den i løpet av få minutter, klikk ',
      secondParagraph2: 'her',
      secondParagraph3: 'så vil vi sende den til deg igjen.',
      error:
        'Kunne ikke sende linken, vennligst kontakt oss om problemet fortsetter.',
      confirmationResent: 'En epost bekreftelse har blitt sendt på nytt.',
    },

    login: {
      title: 'Logg inn',
      newUser: 'Ny bruker?',
      forgotPassword: 'Glemt passord?',
      errorBoxTitle: 'Feil login, vennligst prøv igjen!',
      inactiveAccount: 'Abonnementet er avsluttet, vennligst kontakt kundestøtte',
    },

    resetPassword: {
      title: 'Lag nytt passord',
      firstParagraph:
        'Vi sender deg en epost med link for hvordan lage nytt passord.',
      successMessage:
        'En epost har blitt sendt til din adresse. Vennligst sjekk denne for å lage nytt passord.',
    },

    smsTwoFactorVerification: {
      title: 'SMS tofaktorautentisering',
      enabled: 'Aktivert',
      verificationCodeSent: 'Bekreftelseskoden er sendt til mobilnummeret ditt',
      successMessage: 'Bekreftet kode',
      verificationCodeIncorrect: 'Koden du skrev inn er feil',
      enableWarningMessage:
        'Slik aktiverer du SMS-tofaktorautentisering på kontoen din: <br/> <br/> 1. Skriv inn mobilnummeret ditt og klikk Send kode. <br/> 2. Angi bekreftelseskoden du mottok.',
      verifyMobileNUmber: 'Bekreft mobilnummeret ditt',
      enterMobileNUmber: 'Angi mobilnummer',
      sendCode: 'Send kode',
      resendCode: 'Send kode på nytt',
      codeVerification: 'Kodeverifisering',
      enterToken: 'Skriv inn kode',
      verifyCode: 'Bekreft kode',
      invalidMobileNumber: 'Mobilnummeret du oppga er ugyldig.',
      requiredMobileNumber: 'Skriv inn mobilnummeret ditt.',
      unableToSendVerification: 'Kan ikke sende bekreftelseskode',
      smsTwoFactorAuthEnabled:
        'SMS tofaktorautentisering er aktivert på kontoen din.',
      google2faEnabledWarning:
        'Googles tofaktorautentisering er for øyeblikket aktivert på kontoen din, bare en tofaktorautentiseringsmodul kan aktiveres om gangen.',
    },

    googleTwoFactorVerification: {
      title: 'Googles tofaktorautentisering',
      enabled: 'Aktivert',
      successMessage: 'Bekreftet kode.',
      verificationCodeIncorrect: 'Koden du skrev inn er feil',
      enableWarningMessage:
        'Slik aktiverer du Google Two Factor Autentication på kontoen din: <br/> <br/> <b> 1. Skann QR-koden nedenfor med Google Authenticator App. <br/> 2. Skriv inn bekreftelseskoden, og klikk Bekreft kode. </b>',
      codeVerification: 'Bekreftelseskode',
      enterToken: 'Skriv inn kode',
      verifyCode: 'Bekreft kode',
      smsTwoFactorAuthEnabled:
        'Google tofaktorautentisering er aktivert på kontoen din.',
      sms2faEnabledWarning:
        'SMS tofaktorautentisering er for øyeblikket aktivert på kontoen din, bare en tofaktorautentiseringsmodul kan aktiveres om gangen.',
    },

    dashboard: {
      title: 'Kontrollpanel',
      emailConfirmationTitle: 'Før du går videre må du bekrefte eposten din',
      emailConfirmationText1:
        'Før vi gir deg tilgang til å bruke kontoen trenger vi at du bekrefter epost adressen din. Dette gjør vi for å sikre at ingen uvedkommende registrerer seg med din epost adresse.',
      emailConfirmationText2:
        'Alt du trenger å gjøre er å sjekke epost kontoen din og åpne eposten vi har sendt deg. (Husk å sjekke spam/søppel mappa hvis du ikke finner eposten).',
      emailConfirmationText3:
        'I eposten følger du enkelt bekrivelsen og klikker på lenken for å bekrefte din registrering. Du finner også ditt passord for å logge inn på Kundan i denne eposten.',
      emailConfirmationText4:
        'PS! Hvis du av en eller annen grunn ikke finner eposten vi har sendt deg, kan du alltids få tilsendt eposten på nytt ved å klikke på lenken under:',
      emailConfirmationResendButton:
        'Klikk her for å sende meg en ny bekreftelses-epost',
      emailConfirmationResendLoading: 'Sender epost... vennligst vent!',
      emailConfirmationResent: 'Ny epost har nå blitt sendt!',
      emailConfirmationText5:
        'PS! Det kan ta noen minutter før eposten dukker opp. Nøl ikke med å kontakt oss hvis problemer oppstår underveis',
      emailConfirmationResentWarning:
        'Verifiserings-epost sendt. Vennligst sjekk eposten din.',
      emailConfirmationResentError:
        'Vi kunne dessverre ikke sende verifiserings-eposten akkurat nå, vennligst prøv igjen senere eller ta kontakt med support hvis problemet ikke løser seg.',
      expiredSubscriptionWarning:
        'Ditt abonnement har utløpt. Vennligst forny eller velg et abonnement som er mer passende.',
      updateInformation: 'Vennligst oppdater følgende felter.',
      fieldsMissing: 'Felt mangler',
      completed: 'FULLFØRT',
      accountInformation: 'Kontoinformasjon',
      organizationSettings: 'Firma innstillinger',
      addWidgetBtn: 'Legg til widget',
    },

    bulkProductAdd: {
      emptySelectionError: 'Legg til minst én vare!',
      saveError: 'Kunne ikke lagre. Sjekk detaljene og prøv igjen.',
    },
    bulkAddProducts: {
      selectedProducts: {
        title: 'Valgte produkter',
        noneSelected: 'Ingen produkter valgt',
        productName: 'Produkt',
        productQty: 'Antall',
        unitTypeId: 'Enhet',
        unitQty: 'Antall',
        qty: 'Total',
        available: 'Lagerantall',
      },
      findProducts: {
        search: 'Skriv inn produktnavn...',
      },
    },

    supplier: {
      index: {
        title: 'Leverandør',
      },
      filters: {
        title: 'Leverandører',
        today: 'I dag',
        all: 'Alle',
      },
      create: {
        title: 'Opprett leverandør',
        success: 'Leverandør opprettet!',
      },
      update: {
        title: 'Oppdater leverandør',
        success: 'Leverandør oppdatert!',
      },
      edit: {
        supplier: 'Leverandør',
      },
      info: {
        phone: 'Telefon',
        email: 'Epost',
        code: 'Kode',
        name: 'Navn',
        streetName1: 'Adresse',
        streetName2: 'Adresse 2',
        country: 'Land',
        city: 'By',
      },
    },

    warehouse: {
      index: {
        title: 'Varelager',
      },
      transactionNavigation: {
        addTransaction: 'Opprett transaksjon',
        stockCount: 'Lagertelling',
        stockAdjustment: 'Lagerjustering',
        transfer: 'Overføring',
        purchase: 'Innkjøp',
      },
      filters: {
        title: 'Varelager',
        today: 'I dag',
        all: 'Alle',
        view: 'Vis varelager',
      },
      create: {
        title: 'Opprett lager',
        success: 'Varelager opprettet!',
      },
      update: {
        title: 'Oppdater lager',
        success: 'Varelager oppdatert!',
      },
      cancel: {
        title: 'Kanseller innkjøp',
        success: 'Innkjøp kansellert',
        error: 'En feil oppsto under kansellering',
      },
      pending: {
        title: 'Innkjøp på vent',
        success: 'Innkjøp oppdatert',
        error: 'Feil ved innkjøp',
      },
      edit: {
        supplier: 'Varelager',
      },
      addTransaction: {
        title: 'Opprett transaksjon',
      },
      info: {
        location: 'Sted',
        name: 'Navn',
        isBonded: '(Tollager / Ubeskattede varer)',
        notBonded: '(Beskattede varer)',
        type: 'Type',
        locked: ' (låst)',
      },
      formTabs: {
        products: 'Produkter',
        transactions: 'Transaksjoner',
      },
      products: {
        noDataMsg: 'Ingen produkter funnet på lager',
        name: 'Produktnavn',
        batchName: 'Batch',
        qty: 'Lagermengde',
        minimumStockLevel: 'Minimum lagerbehov',
        producer: 'Produsent',
        hideOutOfStock: 'Skjul utsolgte produkter',
        bulkDestroyProducts: 'Destruer produkter',
      },
      transactions: {
        noDataMsg: 'Ingen transaksjoner registrert',
        table: {
          qty: 'Antall',
          via: 'Type',
          code: 'Nummer',
          createdAt: 'Dato',
          id: 'ID #',
          productName: 'Produkt',
          beforeqty: 'Før',
          totalQty: 'Antall',
          afterqty: 'Etter',
          status: 'Status',
          client: 'Kunde',
          warehouse: 'Varelager',
          billingNumber: 'Faktura',
          batchName: 'Parti',
        },
        filter: {
          transactionType: [
            {
              value: 'all',
              label: 'Alle transaksjonstype',
            },
            {
              value: 'SO',
              label: 'Salgsordre',
            },
            {
              value: 'PO',
              label: 'Innkjøpsordre',
            },
            {
              value: 'PA',
              label: 'Innkjøpsordre justert',
            },
            {
              value: 'SC',
              label: 'Lagertelling',
            },
            {
              value: 'AJ',
              label: 'Lagerjustering',
            },
            {
              value: 'TW',
              label: 'Overføring mellom lager',
            },
            {
              value: 'TB',
              label: 'Fra batch',
            },
            {
              value: 'TL',
              label: 'Overføring fra annen bevillingshaver',
            },
            {
              value: 'RS',
              label: 'Retur av salg',
            },
            {
              value: 'OC',
              label: 'Ordre kansellering',
            },
            {
              value: 'BI',
              label: 'Batch ingredienser',
            },
            {
              value: 'PD',
              label: 'Destruksjon',
            },
            {
              value: 'TC',
              label: 'Korrigering',
            },
          ],
        },
      },
    },
    unitOfMeasure: {
      index: {
        title: 'Unit of Measures',
      },
      filters: {
        title: 'Unit of Measures',
        today: 'Today',
        all: 'All',
      },
      create: {
        title: 'Create Unit of Measures',
        success: 'Successfully Created',
      },
      update: {
        title: 'Update Unit of Measures',
        success: 'Successfully Updated',
      },
      edit: {
        supplier: 'Unit of Measures',
      },
      info: {
        code: 'Kode',
        qty: 'Antall',
        warehouse: 'Lagersted',
        supplier: 'Leverandør',
        createdAt: 'Opprettet dato',
        name: 'Navn',
        comments: 'Kommentar',
        status: 'Status',
        receiveDate: 'Mottatt dato',
      },
    },

    stock: {
      noData: 'Ingen data funnet.',
      index: {
        title: 'Lagertelling',
      },
      filters: {
        title: 'Vis lagertelling',
        create: 'Opprett lagertelling',
        all: 'Alle',
      },
      create: {
        title: 'Opprett lagertelling',
        success: 'Oppretting vellykket',
      },
      draft: {
        success: 'Successfully save draft',
      },
      view: {
        title: 'Lagertelling',
        details: 'Generell',
        products: 'Produktliste',
        productsLegend: 'Produkttabell',
        adjustment: 'Korrigeringsliste',
        adjustmentLegend: 'Korrigeringstabel',
        detailsLegend: 'Lager detaljer',
      },
      info: {
        code: 'Kode',
        qty: 'Total mengde',
        warehouse: 'Lagersted',
        createdAt: 'Dato opprettet',
        transactionDate: 'Transaksjonsdato',
        name: 'Navn',
        status: 'Status',
      },
      products: {
        sku: 'ID',
        name: 'Produktnavn',
        physicalCount: 'Ny beholdning',
        currentCount: 'Lagerbeholdning',
        variance: 'Forskjell (+/-)',
      },
    },

    purchase: {
      noData: 'Ingen data funnet.',
      index: {
        title: 'Innkjøp',
      },
      filters: {
        title: 'Vis innkjøp',
        create: 'Opprett innkjøp',
        all: 'Alle',
      },
      create: {
        title: 'Opprett innkjøp',
        success: 'Vellykket oppretting av innkjøp',
        unfinished: 'Ikke fullført',
      },
      update: {
        title: 'Oppdater innkjøp',
        success: 'Vellykket oppdatering av innkjøp',
        error: 'En feil oppstod under oppdatering',
      },
      cancel: {
        title: 'Kanseller innkjøp',
        success: 'Kansellering vellykket',
        error: 'En feil oppstod under kansellering',
      },
      pending: {
        title: 'Innkjøp til behandling',
        success: 'Oppdatering vellykket',
        error: 'Feil ved oppdatering',
      },
      view: {
        title: 'Innkjøp',
        details: 'Lagerdetaljer',
        products: 'Produktliste',
        productsLegend: 'Produkttabell',
        adjustment: 'List of Adjustment',
        adjustmentLegend: 'Adjustment Table',
        detailsLegend: 'Innkjøpsdetaljer',
        documentBtnDropdown: 'Dokument',
        sendPurchaseDocument: 'Send innkjøpsdokument',
        downloadPurchaseDocument: 'Last ned innkjøpsdokument',
      },
      info: {
        code: 'Kode',
        qty: 'Antall',
        warehouse: 'Lagersted',
        supplier: 'Leverandør',
        createdAt: 'Dato opprettet',
        name: 'Navn',
        comments: 'Kommentar',
        status: 'Status',
        receiveDate: 'Dato mottatt',
      },
      products: {
        sku: 'ID',
        name: 'Produktnavn',
        qty: 'Antall',
        qtyReceive: 'Antall mottatt',
        qtyDamage: 'Antall ødelagt/manko',
        purchasePrice: 'Innkjøpspris',
        costPrice: 'Kostpris',
        notes: 'Notat',
      },
      status: {
        draft: 'Utkast',
        progress: 'Under behandling',
        cancelled: 'Kansellert',
        done: 'Fullført',
        unfinished: 'Ikke fullført',
        pending_external: 'Venter ekstern godkjenning',
        pending: 'Venter',
      },
    },

    inventory: {
      title: 'Produkter',
      transaction: {
        title: 'Transaksjoner',
      },
      products: {
        create: 'Opprett produkt',
        view: 'Vis produkter',
      },
    },

    adjustment: {
      noData: 'Ingen data funnet.',
      index: {
        title: 'Lagerjustering',
      },
      filters: {
        title: 'Vis lagerjustering',
        create: 'Opprett lagerjustering',
        all: 'Alle',
      },
      create: {
        title: 'Opprett lagerjustering',
        success: 'Oppretting vellykket',
      },
      view: {
        title: 'Lagerjustering',
        details: 'Justeringsdetaljer',
        products: 'Produkter',
        productsLegend: 'Produktoversikt',
        adjustment: 'List of Adjustment',
        adjustmentLegend: 'Adjustment Table',
        detailsLegend: 'Adjustment Details',
      },
      info: {
        code: 'Kode',
        qty: 'Antall',
        stock: 'Beholdning',
        warehouse: 'Lagersted',
        createdAt: 'Dato opprettet',
        reason: 'Årsak',
        status: 'Status',
        adjustmentType: 'Justeringstype',
      },
      products: {
        sku: 'ID',
        name: 'Produktnavn',
        qty: 'Antall',
        exciseAdditionalCode: 'Tilleggskode',
      },
      draft: {
        deleteMessage: 'Ønsker du å slett lagerjusteringen?',
      },
      statuses: {
        adjustment: 'Standardjustering',
        wastage: 'Mankojustering',
        destruction: 'Destruksjon',
      },
    },

    transfer: {
      noData: 'Ingen data funnet.',
      index: {
        title: 'Overføring',
      },
      filters: {
        title: 'Vis overføring',
        create: 'Opprett overføring',
        all: 'Alle',
      },
      create: {
        title: 'Opprett overføring',
        success: 'Oppretting vellykket',
        button: 'Fullfør overføring',
      },
      view: {
        title: 'Overføring',
        details: 'Overføringsdetaljer',
        products: 'Produkter',
        productsLegend: 'Produkter',
        adjustment: 'List of Adjustment',
        adjustmentLegend: 'Adjustment Table',
        detailsLegend: 'Overføringsdetaljer',
      },
      info: {
        code: 'Kode',
        qty: 'Antall',
        stock: 'Beholdning',
        fromWarehouse: 'Fra lager',
        toWarehouse: 'Til lager',
        createdAt: 'Dato opprettet',
        reason: 'Årsak',
        status: 'Status',
      },
      products: {
        sku: 'ID',
        name: 'Produktnavn',
        qty: 'Antall',
      },
      draft: {
        deleteMessage: 'Ønsker du å slett overføringen?',
      },
    },

    reports: {
      downloadReport: 'Last ned rapport',
      exciseEntryLabel: 'Oppføringer',
      noData: 'Ingen data funnet på denne perioden.',
      clients: {
        title: 'Kunderapport',
        client: 'Kunde',
        id: 'ID',
        balance: 'Balanse (kr)',
        createdAt: 'Opprettet dato',
        turnover: {
          groupButton: 'Omsetning',
          viewTurnover: 'Vis omsetningsrapport',
          downloadTurnover: 'Last ned omsetningsrapport',
          emailTurnover: 'Send omsetningsrapport',
          bulk: {
            title: 'Bulksending av omsetningsrapport',
            processing: 'Behandler...',
            clients: 'Valgte kunder',
            noDataSelectedClient:
              'Vennligst vent mens vi zipper filen for deg. De listet under vil ikke bli inkludert i zip-fil.',
            noDataAllSelectedClient:
              'Ingen omsetningsdata funnet på de valgte kundene.',
            yearOf: 'Periode',
          },
        },
        clientSearch: {
          placeholder: 'f.eks. navn eller kundenummer',
        },
      },
      warehouse: {
        warehouse_beta: 'Lagerrapport Beta',
        warehouse: 'Lagerrapport',
        all: 'Alle lagre',
        transactionType: {
          all: 'Alle transaksjonstype',
          groupByProduct: 'Grupper produkter',
        },
        warehouse_required: 'Vennligst velg et lager',
        month_required: 'Velg en måned',
        as_of_date: 'Per dato',
        date_range: 'Datointervall',
        pick_date: 'Velg dato',
      },
      greenDot: {
        detailed: {
          downloadDetailedReport: 'Last ned detaljert rapport',
        },
      },
      exciseEntry: {
        title: 'Avgifter',
        dateRange: {
          placeholder: 'Velg en dato',
        },
        table: {
          group: 'Gruppe',
          description: 'Forklaring',
          totalQuantity: 'Summert antall',
          totalVolume: 'Summert volum',
          unitType: 'Enhetstype',
          exciseEntries: 'Oppslag',
          product_name: 'Produkt',
          product_volume: 'Volum',
          order_id: 'Ordre ID',
          quantity: 'Antall',
          created_at: 'Dato opprettet',
          excisable_id: 'Kilde',
          order_customer_name: 'Kunde',
          receiverName: 'Navn',
        },
      },
      sales: {
        title: 'Ordrerapport',
        export: 'Last ned i Excel',
        exportYtd: 'Last ned HIÅ rapport',
        dateRange: {
          placeholder: 'Velg periode',
          placeholderStart: 'Startdato',
          placeholderEnd: 'Sluttdato',
        },
        group: {
          placeholder: 'Velg filter',
          names: {
            orders: 'Ordre',
            clients: 'Kunder',
            products: 'Produkter',
          },
        },
        id: 'ID',
        status: 'Status',
        name: 'Navn',
        sales: 'Salg (kr)',
        credit: 'Kreditt (kr)',
        total: 'Balanse (kr)',
        clearedInvoices: 'Fakturert (kr)',
        clearedCredit: 'Kreditert (kr)',
      },

      aggregatedSales: {
        title: 'Aggregert salgsrapport',
        export: 'Last ned Excel',
        includeCancelled: 'Inkl. kansellerte',
        dateRange: {
          placeholder: 'Velg periode',
        },
        groupBy: {
          placeholder: 'Grupper etter',
          product: 'Produkt',
          client: 'Kunde',
          clientType: 'Kundetype',
          month: 'Måned',
          year: 'År',
        },
        sort: {
          placeholder: 'Sorter etter',
          revenueDesc: 'Omsetning (høy → lav)',
          revenueAsc: 'Omsetning (lav → høy)',
          volumeDesc: 'Volum (høy → lav)',
          volumeAsc: 'Volum (lav → høy)',
        },
        columns: {
          productName: 'Produkt',
          productNumber: 'Produktnr.',
          clientName: 'Kunde',
          clientNumber: 'Kundenr.',
          clientTypeName: 'Kundetype',
          period: 'Periode',
          totalRevenueNet: 'Omsetning netto (kr)',
          totalRevenueGross: 'Omsetning brutto (kr)',
          totalVolumeLiters: 'Volum (liter)',
          orderCount: 'Antall ordre',
          totalQuantityUnits: 'Antall enheter',
        },
        statuses: {
          label: 'Ordrestatus',
          placeholder: 'Tom = standard (bekreftet, sendt, levert, fakturert)',
          options: {
            confirmed: 'Bekreftet',
            shipped: 'Sendt',
            delivered: 'Levert',
            invoiced: 'Fakturert',
            created: 'Opprettet',
            cancelled: 'Kansellert',
          },
        },
        summary: {
          totalRevenueNet: 'Netto omsetning',
          totalVolumeliters: 'Totalt volum',
          orderCount: 'Antall ordre',
        },
        metrics: {
          label: 'Vis kolonner',
        },
      },

      bills: {
        title: 'Fakturarapport',
        export: 'Last ned Excel',
        invoiceNumber: 'Faktura #',
        billTypeName: 'Type',
        status: 'Status',
        invoiceDate: 'Fakturadato',
        dueDate: 'Forfallsdato',
        customer: 'Kunde',
        email: 'Epost',
        address: 'Adresse',
        sum: 'Sum',
        vat: 'MVA',
        invoiceAmount: 'Fakturabeløp',
        paidAmount: 'Betalt beløp',
        dueAmount: 'Å betale',
        balance: 'Balanse',
        draft: 'Kladd',
        pending: 'Venter',
        sent: 'Sendt',
        sending: 'Sender',
        cleared: 'Betalt',
        partlypaid: 'Delbetalt',
        cancelled: 'Kreditert',
        total: 'Total',
        allClients: 'Alle kunder',
        cash: 'Kontanter',
        banktransfer: 'Bankoverføring',
        paid: 'Betalt',
        due: 'Grunn',
      },
      fees: {
        skatteetaten: {
          title: 'Skatteetaten',
          due_info: 'Forfall 18. hver mnd.',
        },
        helsedir: {
          title: 'Helsedirektoratet',
          due_info: 'Forfall 18. hver mnd.',
        },
        brod: {
          title: 'Bryggeriforeningen',
          due_info: 'Forfall 18. hver mnd.',
        },
        infinitum: {
          title: 'Infinitum',
          due_info: 'Forfall 7. hver mnd.',
        },
        title: 'Avgiftsrapport',
        export: 'Last ned i Excel',
        exportCsv: 'Last ned Elsær',
        filter: 'Filter',
        orderNumber: 'Order #',
        client: 'Kunde',
        excisable: 'Avgiftsberegning',
        productType: 'Varetype',
        internalItemNumber: 'Varenr.',
        externalItemNumber: 'VMP varenr.',
        productName: 'Varenavn',
        producerName: 'Produsent',
        vintage: 'Årgang',
        alcoholPercentage: 'Alkohol (%)',
        bottleVolume: 'Flaskevolum (ℓ)',
        packagingType: 'Emballasjetype',
        corkType: 'Korktype',
        isTaxable: 'Avgiftsberegning',
        numberOfBottlesSold: 'Antall flasker',
        numberOfLitersSold: 'Antall liter',
        all: 'Alle kunder',
        orderProducts: 'Bestillinger',
        order_id: 'Bestillings ID',
        quantity_confirmed: 'Mengde',
        order_date: 'Dato bestilt',
        client_name: 'Klientens navn',
        number: 'Ordrenummer',
        month_placeholder: 'Velg en måned',
        readyToCloseWarning:
          'Denne perioden er nå klar for lukking. Klikk på knappen under for å låse perioden og for å kunne laste ned nødvendige filer for rapportering.',
        changedWarning:
          'Denne perioden har blitt endret. Klikk på knappen under for å låse perioden og for å kunne laste ned nødvendige filer for rapportering.',
        closeButton: 'Lukk',
        confirm: {
          title: 'Lukk avgiftsperiode',
          message:
            'Ønsker du å lukke denne perioden? NB! Dette låser perioden fra flere oppføringer.',
          button: 'Fortsett',
        },
        closeSuccessMessage:
          'Lukking vellykket! Du har nå tilgang til å laste ned dine rapporter under.',
        exciseStatus: {
          ongoing: 'Pågående',
          readyToBeClosed: 'Klar for lukking',
          changed: 'Periode endret',
          closed: 'Lukket',
        },
      },
      brod: {
        export: 'Last ned i Excel',
      },
    },

    accountInformation: {
      title: 'Kontoinformasjon',
      profile: 'Profil',
      basicInformation: 'Basis informasjon',
      userInformation: 'Bruker informasjon',
      generalInformation: 'Generell',
      organizationInformation: 'Enhetsopplysninger',
      businessInformation: 'Firmaopplysninger',
      loginInformation: 'Logg inn informasjon',
      addressInformation: 'Adresse informasjon',
      userSetting: 'Foretrukket innstilling',
      contactInformation: 'Kontakt informasjon',
      passwordTitle: 'Endre passord',
      accountSaveSuccess: 'Kontoinformasjon lagret.',
      passwordSaveSuccess: 'Passord lagret.',
      addressSaveSuccess: 'The address and contact was successfully updated.',
      general: 'Generelle',
      email: 'Email',
      booking: 'Booking',
      accounting: 'Regnskap',
      shippingProvider: 'Fraktleverandør',
      project: 'Prosjekter',
      twoFactorAuthentication: 'To-faktor autentisering',
      advance: 'Prisjustering',
    },

    profileAddress: {
      title: 'Adresseinformasjon',
      addressSaveSuccess: 'Adresse lagret.',
    },

    profileContact: {
      title: 'Kontaktinformasjon',
      addressSaveSuccess: 'Kontakt lagret.',
    },

    organizationSettings: {
      title: 'Innstillinger',
      ediSettings: 'EDI innstillinger',
      settingsSaveSuccess: 'Organistasjonsinstillinger lagret.',
      settingsSaveError: 'Kunne ikke lagre organisasjonsinnstillinger.',
      disabledFieldTooltips:
        'Dette feltet kan ikke endres etter funksjonen er tatt i bruk',
      messageTemplates: 'Tilpass e-postene dine',
      booking: 'Booking',
      payment_identification: 'KID',
      accounting: 'Eksport av regnskapsdata',
      coa: {
        title: 'Kontoplan',
        noCoa: 'Kontoplan er ikke opprettet ennå',
        createCoa: 'Opprett Kontoplan',
        code: {
          label: 'Kode',
          placeholder: 'Kode',
        },
        name: {
          label: 'Navn',
          placeholder: 'Navn',
        },
        description: {
          label: 'Beskrivelse',
          placeholder: 'Beskrivelse',
        },
        orgDefault: {
          label: 'Standardkonto',
          none: 'Ingen',
          receivables: 'Fordringer',
          income: 'Inntekt',
          vat: 'MVA',
          deposit: 'Pant',
        },
      },
      ediBillingMethod: {
        options: {
          auto: 'Automatisk - Fakturaoppretting og sending',
          halfAuto: 'Halv automatisk - Fakturaoppretting, manuell sending',
          manuel: 'Manuell - Manuell oppretting og sending av faktura',
        },
      },
      emailInvoiceCopy: {
        title: 'Epost for fakturakopi',
      },
      ediNotifyRecipients: {
        title: 'Mottakere av Edi-varsling',
        addBtn: 'Ny e-post',
      },
      lowStockNotifyRecipients: {
        title: 'Mottakere av lagervarsling',
        addBtn: 'Ny e-post',
      },
      bulk_price_update: 'Bulk prisoppdatering',
      summary: 'Sammendrag',
      bulk_price_update_success: 'Produkt(er) pris oppdatert!',
      bulk_price_update_status: {
        running: {
          title: 'Bulkoppdateringen pågår...',
          description: 'Systemet vil automatisk sende en e-post når prosessen er fullført. Vennligst vent til den er ferdig før du starter en ny oppdatering.',
        },
        failed: {
          title: 'Bulkprisoppdateringen mislyktes',
          description: 'Systemet opplevde et problem under prosessen. Som et resultat har vi avbrutt og reversert endringene. Vennligst kontakt vårt supportteam, og vi vil undersøke problemet. Når det er løst, vil vi varsle deg og la deg kjøre oppdateringen igjen.',
        },
      },
      bulk_price_update_entries: {
        title: 'Historiske Prisjusteringer',
      },
      bulkPriceUpdateHistory: {
        date: 'Tidspunkt',
        percentage: '%',
        roundingRules: 'Avrunding',
        priceTypes: 'Pristype',
      },
      completed: 'Fullført',
      failed: 'Mislykket',
    },

    publicProfile: {
      title: 'Booking innstillinger',
      profileSettings: 'Profile Settings',
      mainSettings: 'Offentlig side informasjon',
      checkoutSettings: 'Utsjekkingsinnstillinger',
      connectToStripe: 'Koble til Stripe',
      stripeConnected: 'Stripe er tilkoblet',
      defaults: 'SMS og epost maler',
      profileUrl: 'Din booking nettside',
      updateSucess: 'Booking innstillinger lagret.',
    },

    businessHours: {
      title: 'Bedriftstider',
      businessHoursTitle: 'Åpningstider',
      businessHourExceptionsTitle: 'Unntakstid',
      exceptionalHoursSaveKeep: 'Beholde avtaler',
      exceptionalHoursSaveCancel: 'Kansellere avtaler',
    },

    checkout: {
      connectToStripe: 'Koble til Stripe',
      stripeConnected: 'Stripe tilkoblet',
      checkoutSettings: 'Utsjekkingsinstillinger',
    },

    clientGroups: {
      index: {
        title: 'Kundegruppe oversikt',
        clientsCount: ' kunder',
        confirmDelete: 'Dette vil permanent slette gruppen. Fortsette?',
        confirmDeleteTitle: 'Slette kundegruppe',
        deleteHasClientsError: 'Kan ikke slette gruppen med kunder.',
        deleteError: 'Kundegruppen kan ikke slettes.',
      },
      create: {
        title: 'Legg til kundegruppe',
        success: 'Kundegruppe lagt til!',
      },
      edit: {
        title: 'Endre kundegruppe',
        success: 'Kundegruppe oppdatert!',
      },
    },

    clients: {
      organizationNumber: 'Hent fra Brreg',
      info: {
        clientNumber: 'Kunde #:',
        organizationNumber: 'Organisasjonsnummer:',
        billType: 'Faktureringsvalg:',
        phone: 'Telefon:',
        email: 'Epost:',
        totalOrders: 'Total ordre:',
        totalRevenue: 'Total fortjeneste:',
        pendingPayments: 'Venter betaling:',
        clientType: 'Kunde type:',
        clientGroup: 'Kunde gruppe:',
        firstName: 'Fornavn',
        lastName: 'Etternavn',
        phoneNumber: 'Telefonnummer:',
        mobileNumber: 'Mobilnummer:',
        streetName: 'Adresse:',
        secondStreetName: 'Adresse 2:',
        postalCode: 'Postkode:',
        city: 'By:',
        orders: 'Antall ordre',
        bills: 'Antall fakturaer',
        totalBought: 'Sum fakturert',
        totalPending: 'Sum fakturert, ikke betalt',
        systemGenerated: 'System generert',
        ehfInvoiceSupport: 'EHF-faktura (Peppol)',
        ehfSupport: {
          yes: 'Ja — registrert for EHF 3.0 i Peppol',
          no: 'Nei — ikke registrert for EHF 3.0 (lagre kunde med org.nr for ny sjekk)',
          needsOrgNumber: 'Kan ikke verifisere — legg inn organisasjonsnummer',
        },
        ehfListLabel: 'EHF (Peppol)',
        ehfListVerified: 'Verifisert for EHF-faktura',
        ehfListNotVerified: 'Ikke verifisert for EHF-faktura',

        value: {
          billType: {
            options: {
              single: 'Enkeltvis',
              consolidate: 'Samlet',
            },
          },
        },
      },
      index: {
        bulkMaxLimitExceededError:
          'Du har valgt for mange fakturaer! Vennligst reduser antall markerte fakturaer til maks',
        editTooltip: 'Rediger klientprofil',
        deleteTooltip: 'Slett klient',
        title: 'Kundeoversikt',
        confirmDelete:
          'Dette vil permanent slette kunden og ordrene. Fortsette?',
        confirmDeleteTitle: 'Slett kunde',
        downloadAllClients: 'Last ned kunder',
        importClients: 'Dra og slipp Excel fil for importering av kunder...',
        importClientsErrorMessage:
          'En feil oppsto under import. Vennligst sjekk filen og prøv på nytt.',
        importClientsSuccessMessage: 'Import vellykket!',
        importData: 'Import Data',
        exportData: 'Export Data',
        sortName: {
          placeholder: 'Sorter',
        },
        searchName: {
          placeholder: 'Søk',
        },
        search: {
          placeholder: 'Søk på navn, e-post eller organisasjonsnummer',
        },
        listing: {
          placeholder: 'Select Type',
        },
        phoneNumber: 'Telefonnummer',
        email: 'Epost',
      },
      table: {
        name: 'Navn',
        custNo: 'Kundenr.',
        organizationNumber: 'Org.nr.',
        billType: 'Faktureringsvalg',
        phone: 'Telefon',
        email: 'Epost',
        ehf: 'EHF',
        ordersCount: 'Ordreantall',
        createdAt: 'Opprettet',
        parentClient: 'Foreldre klient',
        billMainParent: 'Bill hovedforelder',
      },
      delete: {
        title: 'Advarsel',
        confirm:
          'Ønsker du å slette kunden? Kunder med ordre kan ikke slettes.',
        success: 'Kunden slettet',
      },
      create: {
        title: 'Legg til kunde',
        success: 'Oppretting vellykket!',
        brrig: {
          warning: 'Ingen match funnet hos Brønnøysundregistrene',
        },
        gotoEdit: 'Legge til flere detaljer',
        addMore: 'Opprett en ny kunde',
        gotoIndex: 'Gå til kundeoversikten',
      },
      edit: {
        title: 'Endre kunde',
        clientInfo: 'Kundeinformasjon',
        success: 'Kunde oppdatert!',
        overview: 'Oversikt',
        clientOrders: 'Kundeordrer',
        latestOrders: 'SISTE ORDRER',
        latestBills: 'SISTE FAKTURAER',
        recentActivities: 'SISTE AKTIVITET',
        viewAll: 'SE ALLE',
        allBills: 'Alle fakturaer',
        bills: 'FAKTURAER',
        allActivities: 'All aktivitet',
        activities: 'AKTIVITETER',
        allOrders: 'Alle ordrer',
        orders: 'ORDRER',
        editInformation: 'Endre informasjon',
        totalOrders: 'TOTAL ORDRER',
        totalBills: 'TOTAL FAKTURAER',
        totalActivities: 'TOTAL AKTIVITET',
        noActivity: 'Ingen aktivitet',
        errorNoClient: 'Vennligst velg klienten',
        glnSuccess: 'GLN-nummer og koordinater er tilgjengelig, se feltene.',
        glnError: 'Finner ikke GLN-nummer og koordinater, sjekk organisasjonsnummeret!',
      },
      catalogues: {
        title: 'EHF katalog',
        sendCatalogue: 'Send EHF katalog',
        actionCodes: {
          add: 'Ny',
          update: 'Oppdater',
          replace: 'Erstatt',
          delete: 'Slett',
        },
      },
    },

    productGroups: {
      formTabs: {
        groupInformation: 'Gruppe informasjon',
        pricingOptions: 'Pris detaljer',
      },
      filters: {
        title: 'Produktgruppe',
        latest: 'Siste',
        pastMonth: 'Siste mnd.',
        all: 'Alle',
      },
      index: {
        title: 'Produktgruppe oversikt',
        productsCount: ' produkter',
        confirmDelete: 'Dette vil permanent slette gruppen. Fortsette?',
        confirmDeleteTitle: 'Slette produktgruppe',
        deleteHasProductError: 'Kan ikke slette gruppen med produkter.',
        deleteError: 'Produktgruppe kan ikke slettes.',
      },
      create: {
        title: 'Opprett produktgruppe',
      },
      edit: {
        title: 'Endre produktgruppe',
      },
    },

    productPackagings: {
      formTabs: {
        packagingInformation: 'Forpakninger',
        pricingOptions: 'Pricing Options',
      },
      filters: {
        title: 'Forpakninger',
        all: 'Alle',
      },
      index: {
        title: 'Forpakninger',
        productsCount: ' produkter',
        confirmDelete: 'Dette vil slette forpakningen. Ønsker du å fortsette?',
        confirmDeleteTitle: 'Slett orodukt forpakning',
        deleteHasProductError:
          'Kan ikke slette forpakning tilknyttet produkter.',
        deleteError: 'Produkt forpakning kunne ikke slettes.',
      },
      create: {
        title: 'Opprett forpakning',
        success: 'Forpakning opprettet',
      },
      edit: {
        title: 'Rediger forpakning',
        success: 'Forpakning oppdatert',
        delete: 'Produktforpakning slette',
      },
    },

    productTags: {
      formTabs: {
        tagInformation: 'Stikkord informasjon',
      },
      index: {
        title: 'Produkt stikkord',
        productsCount: ' products',
      },
      filters: {
        title: 'Produkt stikkord',
        all: 'Alle',
      },
      create: {
        title: 'Opprett stikkord',
        success: 'Produkt stikkord opprettet!',
      },
      edit: {
        title: 'Rediger stikkord',
        success: 'Produkt stikkord endret!',
      },
    },

    priceFields: {
      formTabs: {
        tagInformation: 'Field Information',
      },
      index: {
        title: 'Price Field',
        productsCount: ' products',
      },
      filters: {
        title: 'Price Fields',
        all: 'All',
      },
      create: {
        title: 'Add Price Field',
        success: 'Product Price Field successfully',
      },
      edit: {
        title: 'Edit Price Field',
        success: 'Price Field edited successfully',
      },
    },
    campaigns: {
      listNotSetup:
        'Sett opp listen på denne kampanjen ellers blir ikke nyheter sendt!',
      noDataMsg: 'Ingen kampanje-e-post funnet',
      index: {
        title: 'Kampanje oversikt',
        description: 'Forklaring',
        campaignType: 'Type',
        confirmDelete:
          'Dette vil slette hele kampanjen. Ønsker du å fortsette?',
        confirmDeleteTitle: 'Slett kampanje',
        deleteHasClientsError:
          'Kan ikke slette kampanje som inneholder eposter.',
        deleteError: 'Kampanjen kunne ikke slettes.',
      },
      create: {
        title: 'Legg til kampanje',
        tabTitle: 'Kampanjen informasjon',
        campaignTypeTooltip:
          'Sequence: test description. <br/><br/> Broadcast: test description.',
      },
      edit: {
        title: 'Rediger kampanje',
        campaignInfo: 'Kampanjen informasjon',
        overview: 'Kampanjen oversikt',
        emails: 'Eposter',
        emailBodyTooltip:
          'Tilgjengelige variabler:<br/><br/>Fornavn på kunde: {customer_firstname}<br/>Etternavn på kunde: {customer_lastname}',
        clients: 'Kunder',
        totalSubscribers: 'Abonnementer',
        unsubscribed: 'Avmeldte',
        bounced: 'Retur',
        latestSubscribers: 'Siste påmeldte',
        latestUnsubscribed: 'Siste avmeldte',
        latestBounced: 'Siste returnerte',
        viewAll: 'Vis alle',
        updateSuccess: 'Kampanjen ble lagret!',
        removeClientError: 'Kunde kunne ikke bli slettet fra kampanjen.',
        addClients: {
          placeholder: 'Velg kunde',
        },
        addClientGroups: {
          placeholder: 'Velg kundegruppe',
        },
        emailTracking: {
          noDataMsg: 'Ingen poster funnet',
          dateRange: 'Datointervall:',
          countLabel: {
            opened: 'åpnet',
            delivered: 'leveres',
            clicked: 'klikket',
            dropped: 'droppet',
            bounced: 'Returnerte',
            complained: 'klaget',
            failed: 'mislyktes',
            unsubscribed: 'utmeldings',
          },
          graphLabel: 'Kurve',
          recipientLabel: 'mottakere',
          noRecipientAvailable: 'Ingen mottakere tilgjengelig',
          dateRangDropDown: {
            group1: 'Tekst med ikon',
            today: 'I dag',
            all: 'Alle',
            group2: 'Linjediagram',
            dateRange: 'Datointervall',
          },
          datePicker: {
            shortcut: {
              last3Days: 'Siste 3 dager',
              lastWeek: 'Forrige uke',
              lastMonth: 'Last Month',
              last3Month: 'Forrige måned',
            },
          },
        },
      },
    },

    subscriberList: {
      index: {
        title: ' oversikt',
        description: 'Beskrivelse',
        confirmDelete: 'Dette vil slette listen permanent. Fortsette?',
        confirmDeleteTitle: 'Slett liste',
        deleteError: 'Listen kunne ikke slettes.',
        topInfo: 'Listeinfo.',
        fromEmail: 'e-post',
        fromName: 'Navn',
        emailCount: 'Antall e -poster',
      },
      create: {
        title: 'Lag liste',
        tabTitle: 'Liste informasjon',
      },
      edit: {
        sendingEmailLoading:
          'Vi sender optin link for hver e-post, vennligst vent ...',
        filterLabel: 'Filtrer etter:',
        tab1Title: 'abonnenter',
        tab2Title: 'Innstilling',
        tab3Title: 'Regler',
        title: 'Rediger abonnentliste',
        overview: 'Oversikt over abonnentliste',
        totalSubscribers: 'abonnenter',
        unsubscribed: 'utmeldings',
        latestSubscribers: 'Siste abonnenter',
        latestUnsubscribed: 'Siste avmelding',
        viewAll: 'Se alt',
        deleteList: 'Slett liste',
        delete: 'Slett',
        deleteConfirmHeaderMsg: 'Advarsel',
        deleteConfirmBodyMsg:
          'Ønsker du å slette denne listen ?, Denne listen vil bli slettet permanent.',
        addClients: {
          placeholder: 'Velg klienter',
        },
        addClientGroups: {
          placeholder: 'Velg klientgrupper',
        },
        subscribers: {
          subscribeSwitchTooltip: 'Foreløpig: subcirbed',
          unsubscribeSwitchTooltip: 'Foreløpig: melde deg ut',
          delete: 'Slett',
          deleteConfirmHeaderMsg: 'Advarsel',
          deleteConfirmBodyMsg:
            'Ønsker du å slette denne e-postmeldingen ?, Denne e-posten vil ikke lenger være en del av denne listen.',
          alreadyInList: '- allerede på denne listen',
          subscribeConfirmHeaderMsg: 'Advarsel',
          subscribe: 'Abonnere',
          unsubscribe: 'Avslutte abonnementet',
          ableToReceive:
            'Ønsker du å abonnere på denne e-postmeldingen? Denne e-posten vil motta nyhetsbrev.',
          unableToReceive:
            'Ønsker du å melde deg av denne e-postmeldingen? Denne e-posten vil ikke lenger motta nyhetsbrev.',
          groupModalHeaderTitle: 'Kundegruppe:',
          groupModalCancel: 'Avbryt',
          groupModalApply: 'Søke om',
        },
        filters: {
          all: 'Alle',
          unsubscribe: 'Avslutte abonnementet',
        },
      },
    },

    news: {
      index: {
        title: 'Epost oversikt',
        confirmDelete: 'Dette vil slette eposten. Fortsett?',
        confirmDeleteTitle: 'Slett epost',
        deleteError: 'Epost kunne ikke slettes',
      },
      create: {
        title: 'Opprett epost',
        createSucess: 'Epost opprettet!',
        sendTestSucess: 'Send epost test',
      },
      edit: {
        title: 'Rediger epost',
        updateSucess: 'Epost oppdatert.',
      },
    },

    products: {
      types: {
        product: 'Produkt',
        bundle: 'Pakke',
        service: 'Tjeneste',
        plan: 'Plan',
        beverage: 'Drikkevare',
        child: 'Sub-produkt',
        beer: 'Øl',
        mead: 'Mjød',
        wine: 'Vin',
        liquor: 'Brennevin',
        cider: 'Sider',
        carbonated: 'Kullsyreholdige',
        nonCarbonated: 'Kullsyrefri',
        material: 'Materialer',
        alcohol: 'Alkohol',
        nonAlcohol: 'Alkoholfri',
        lightWine: 'Svakvin',
        strongWine: 'Sterkvin',
      },
      formTabs: {
        productInformation: 'Produkt informasjon',
        pricingOptions: 'Produkt detaljer',
        inventory: 'Varelager',
        transactions: 'Transaksjoner',
        transactionsOld: 'Transaksjoner (ikke gyldig)',
        mergeProduct: 'Produkt sammenslåing',
        childProducts: 'Tilhørende produkter',
        syncDetails: 'Detaljer',
      },
      labels: {
        priceAndTax: 'Pris og avgifter',
        productDetails: 'Produktdetaljer',
        mergeProduct: 'Produktsammenslåing',
        productInformation: 'Produktinformasjon',
        priceForm: 'Pris og avgifter',
        detailsForm: 'Produktdetaljer',
        exciseForm: 'Særavgiftsdetaljer',
        packagingForm: 'Forpakningsdetaljer',
        productIndentification: 'Produkt identifikasjon',
        marketplace: 'DrikkeRiket',
        alcohol: 'Alkohol',
        alcoholFree: 'Alkoholfri',
        onlineStore: 'Nettbutikk',
      },
      filters: {
        title: 'Produkter',
        latest: 'Siste',
        pastMonth: 'Siste mnd.',
        all: 'Alle',
        withDeposit: 'Med pant',
        active: 'Aktive',
        deactivated: 'Inaktive',
        asko: 'Tilgjengelig Asko',
        vinhuset: 'Tilgjengelig Vinhuset',
        marketplace: 'Tilgjengelig DrikkeRiket',
        onlineStore: 'Tilgjengelig Nettbutikk',
        materials: 'Materialer',
        placeholder: 'Velg filter',
        type: 'Type',
        producer: 'Produsent',
        alcohol: 'Alkohol',
        alcoholFree: 'Alkoholfri',
      },
      index: {
        title: 'Produktoversikt',
        confirmDelete: 'Dette vil permanent slette produktet. Fortsette??',
        confirmDeleteTitle: 'Slett produkt',
        downloadAllProducts: 'Last ned alle produkter',
        importProducts:
          'Dra og slipp Excel fil for importering av produkter...',
        importProductsErrorMessage:
          'En feil oppsto under import. Vennligst sjekk filen og prøv på nytt.',
        importProductsSuccessMessage: 'Import vellykket!',
        importProductsErrorPopupTitle: 'Følgende må korrigeres i importen:',
        importData: 'Importer data',
        exportData: 'Eksporter data',
        row: 'Rad',
      },
      create: {
        title: 'Opprett produkt',
        success: 'Produkt opprettet!',
        options: {
          edit: 'Legge til flere detaljer',
          addMore: 'Opprett et nytt produkt',
          gotoIndex: 'Gå til produktoversikten',
        },
        vmp: {
          fetch: 'Hent data fra VMP',
        },
      },
      syncVmp: {
        title: 'Synkroniser VMP',
        validatingData: 'Henter data...',
        added: 'Nye',
        updated: 'Oppdatert',
        noDataToBeSynced: 'Vi fant ingen data å synkronisere.',
        syncSuccess: 'Synkronisering fullført.',
        syncError: 'Feil oppsto under synkroniseringen.',
        inputRequired: 'Vinmonopolet nummer er påkrevd',
        noModuleWarning:
          'Før du kan hente produktdata fra VMP må du aktiverer Vinmonopolet modulen. Gå til <a href="/#/modules" target="_blank">"Moduler"</a> for å aktivere.',
        existingProducts: 'Eksisterende produkter',
        newProducts: 'Nye produkter',
        syncFieldTitle: 'Produktsynkronisering',
        packagingPopupTitle: '',
        fields: {
          name: 'Navn',
          type: 'Produkttype',
          subtype: 'Velg subtype',
          retailPriceVmp: 'Utsalgspris VMP',
          producer: 'Produsent',
          country: 'Land',
          vintage: 'Årgang',
          alcohol_percentage: 'Alkohol %',
          bottle_volume: 'Flaskevolum',
          cork_type: 'Korktype',
          packaging_material: 'Emballasjetype',
          gtin: 'GTIN',
          colour: 'Farge',
          odour: 'Lukt',
          region: 'Distrikt',
          subRegion: 'Underdistrikt',
          sugar: 'Sukker',
          acid: 'Syre',
          fullness: 'Fylde',
          freshness: 'Friskhet',
          tannins: 'Garvestoffer',
          bitterness: 'Bitterhet',
          sweetness: 'Sødme',
          taste: 'Smak',
          recommendedFood: 'Anbefalt mat',
          storagePotential: 'Lagringsgrad',
          ingredients: 'Ingredienser',
          organic: 'Økologisk',
          biodynamic: 'Biodynamisk',
          locallyProduced: 'Lokalprodusert',
          environmentallySmart: 'Fairtrade',
          freeOrLowOnGluten: 'Lav på gluten',
          kosher: 'Kosher',
        },
      },
      edit: {
        title: 'Endre produkt',
        success: 'Produkt endret!',
        error: 'Produkt oppdatering feilet. Vennligst sjekk for mangler.',
      },
      delete: {
        title: 'Advarsel',
        confirm: 'Slett dette produktet?',
        success: 'Produktet er slettet',
        imageConfirm: 'Ønsker du å slette produktbildet?',
        imageSuccess: 'Produktbilde slettet',
      },
      warehouse: {
        noDataMsg: 'Ingen varelager funnet på dette produktet',
        table: {
          qty: 'Antall',
          name: 'Lagersted',
          warehouseId: 'Lager #',
          batchName: 'Parti',
          totalValue: 'Verdi',
        },
      },
      merge: {
        success: 'Produktet ble flettet',
      },
      transactions: {
        noDataMsg: 'Ingen transaksjoner funnet',
        table: {
          beforeqty: 'Før',
          qty: 'Antall',
          afterqty: 'Etter',
          via: 'Type',
          code: 'ID/Nummer',
          createdAt: 'Dato',
          id: 'ID #',
          status: 'Status',
          client: 'Kunde',
          warehouse: 'Lagersted',
          billingNumber: 'Faktura #',
          productName: 'Produkt',
          batchName: 'Batch',
        },
      },
      table: {
        id: 'ID',
        price: 'Pris',
        name: 'Produktnavn',
        qty: 'Antall',
        warehouses: 'Lagersted',
        description: 'Forklaring',
        number: 'Produktnr',
        externalId: 'Eksternt produktnr',
        case: 'kasse(r)',
        loose: 'løse',
        total: 'totalt',
      },
      indexSettings: {
        displayType: 'Visningstype',
        groupBy: 'Grupper',
        views: {
          grid: 'Rutenett',
          list: 'Liste',
        },
        groups: {
          None: 'Ingen',
          Producer: 'Produsent',
          Type: 'Produkttype',
        },
      },
    },
    bills: {
      billLines: 'Fakturalinjer',
      formTabs: {
        invoiceInformation: 'Fakturainformasjon',
        edit: 'Rediger faktura',
        emails: 'E-poster',
        reminders: 'Påminnelser',
      },
      message: {
        delete: 'Ønsker du å slette denne eksport filen?',
        title: 'Bekreft sletting',
      },
      filters: {
        title: 'Fakturaer',
        today: 'I dag',
        upcoming: 'Kommende',
        pending: 'Venter',
        sent: 'Sendt',
        overdue: 'Forfalt',
        cancelled: 'Kansellert',
        paid: 'Betalt',
        partlyPaid: 'Delbetalt',
        all: 'Alle',
        creditNote: 'Kreditnota',
        invoice: 'Faktura',
      },
      index: {
        remainingToPay: 'gjenstår å betale',
        bulkMaxLimitExceededError:
          'Du har valgt for mange fakturaer! Vennligst reduser antall markerte fakturaer til maks',
        title: 'Fakturaoversikt',
        confirmDelete: 'Dette vil permanent slette faktura. Fortsette?',
        confirmDeleteTitle: 'Slett faktura',
        deleteError: 'Faktura kan ikke slettes.',
        deleteNotDraftError: 'Kun utkast kan slettes.',
        billStatus: 'Status',
        dueDateFormated: 'Forfallsdato',
        invoiceDateFormated: 'Fakturadato',
        billType: 'Type',
        clientName: 'Kunde',
        quantities: 'mengder',
        confirmActionTitle: 'Vennligst bekreft',
        confirmAction1: 'Ønsker du å ',
        confirmAction2: 'på de',
        confirmAction3: 'valgte fakturaene?',
        email: 'Epost',
        ehf: 'Ehf',
        paid: 'Betalt',
        sent: 'Sendt',
        edi: 'Edi',
        action: {
          markBilledAsPaid: 'merke faktura som betalt',
        },
        overdueBadge: 'Forfalt',
      },
      table: {
        id: 'ID',
        name: 'Faktura',
        paymentDate: 'Betalingsdato',
        type: 'Type',
        status: 'Status',
        client: 'Kunde',
        amountDue: 'Å betale',
        amountPaid: 'Betalt beløp',
        totalGross: 'Sum brutto',
        dueDate: 'Forfallsdato',
        invoiceDate: 'Fakturadato',
      },
      create: {
        title: 'Opprett faktura',
        success: 'Faktura opprettet!',
        orderError: 'Kun en faktura kan opprettes per ordre',
      },
      exportBill: {
        title: 'Eksporter fakturadata',
        btn: 'Generer fakturadata',
        confirmSuccess: 'Successfully created export',
        error: 'Internal Error',
        providerNotSet:
          'Vennligst velg regnskapssystemet for eksport. Se "Innstillinger->Regnskap".',
        datePeriod: 'Velg periode',
        description: {
          label: 'Beskrivelse',
          placeholder: 'Skriv inn beskrivelse (valgfritt)',
        },
        billsDateRange: {
          placeholder: 'Velg periode',
          placeholderStart: 'Fra dato',
          placeholderEnd: 'Til dato',
          label: 'Velg periode',
        },
        download: {
          periode: 'Periode',
          description: 'Beskrivelse',
          provider: 'Regnskapssystem',
          download: 'Last ned',
          noData: 'Ingen data generert',
        },
      },
      edit: {
        orderReference: 'Notat',
        title: 'Faktura',
        detailsLegend: 'Fakturadetaljer',
        billStatus: 'Status',
        sourceOrder: 'Source Order',
        sourceBill: 'Source Bill',
        customerDetails: 'Kundedetaljer',
        address: 'Adresse',
        updateSuccess: 'Faktura oppdatert.',
        sendPreviewInfo: 'Vennligst vent...',
        creditNoteTitle: 'Endre kreditnota',
        showInvoiceBtn: 'Vis faktura',
        downloadInvoiceBtn: 'Last ned faktura',
        showCreditNoteBtn: 'Vis kreditnota',
        downloadCreditNoteBtn: 'Last ned kreditnota',
        sendInvoiceBtn: 'Send e-post faktura',
        sendEdiInvoiceBtn: 'Send faktura (EDI)',
        sendEdiCreditNoteBtn: 'Send kreditnota (EDI)',
        sendEhfInvoiceBtn: 'Send EHF',
        sendInvoiceEmailFallbackBtn: 'Send faktura på e-post (avviker fra kundens valg)',
        sendCreditNoteEmailFallbackBtn: 'Send kreditnota på e-post (avviker fra kundens valg)',
        ehfNotVerifiedTitle: 'EHF er ikke klar for denne kunden',
        ehfNotVerifiedBody:
          'Kunden har EHF som fakturametode, men Peppol-verifisering (EHF 3.0) er ikke registrert. Oppdater kunden (lagre på nytt) eller send midlertidig på e-post.',
        ehfNotVerifiedClientLink: 'Gå til kunde',
        ehfNotVerifiedNoEmail:
          'Kunden har ikke e-postadresse; legg inn kontakt på kundekortet før du kan sende på e-post.',
        ehfPreferredOverEmailTitle: 'Kunden kan ta imot EHF',
        ehfPreferredOverEmailBody:
          'Fakturametode er satt til e-post, men kunden er verifisert for EHF (Peppol). For de fleste B2B-fakturaer er EHF å foretrekke. Du kan sende med EHF nå, eller likevel bruke e-post om du må.',
        ehfPreferredOverEmailNoEmail:
          'Uten e-post på kunden kan du ikke sende på e-post her — legg inn e-post på kundekortet, eller send med EHF.',
        ehfPreferredOverEmailSendEhfBtn: 'Send med EHF (anbefalt)',
        ehfPreferredOverEmailSendInvoiceEmailBtn: 'Send faktura på e-post',
        ehfPreferredOverEmailSendCreditNoteEmailBtn: 'Send kreditnota på e-post',
        ehfModuleUpsellTitle: 'Aktiver EHF-modulen for denne kunden',
        ehfModuleUpsellTitleNoPeppolYet: 'Aktiver EHF-modulen først',
        ehfModuleUpsellBody:
          'Kunden er verifisert for EHF (Peppol), men EHF-modulen er ikke aktivert på kontoen din. Med EHF kan du sende B2B-fakturaer elektronisk i stedet for e-post — ofte raskere og mer pålitelig.',
        ehfModuleUpsellBodyNoPeppolYet:
          'Kunden har EHF som fakturametode, men EHF-modulen er ikke aktivert på kontoen din. Aktiver modulen for å sende via EHF. Etterpå kan du lagre kunden på nytt for Peppol-verifisering ved behov, eller sende midlertidig på e-post.',
        ehfModuleUpsellLink: 'Trykk her for å aktivere EHF-modulen',
        ehfModuleUpsellUnavailable: 'EHF-modulen er ikke tilgjengelig akkurat nå. Kontakt support om du trenger hjelp.',
        resendInvoiceBtn: 'Send faktura på nytt',
        sendReminder: 'Send påminnelse',
        overdueInvoiceNotice:
          'Forfallsdato er passert for denne fakturaen. Under fanen Påminnelser kan du sende betalingspåminnelse på e-post.',
        overdueBadge: 'Forfalt',
        invoiceWithReminderFee: 'Påminnelse PDF',
        invoiceSent: 'Faktura sendt',
        sendCreditNoteBtn: 'Send e-post kreditnota',
        sendInvoiceSuccess: 'Faktura ble satt i kø for sending.',
        sendInvoiceError: 'Feil i faktura, vennligst prøv igjen senere.',
        createCreditNoteBtn: 'Opprett kreditnota',
        createNoteError: 'Feil i kreditnota, vennligst prøv igjen senere.',
        creditNoteProducttitle: 'Kreditnota',
        noCreditNoteSource: 'Ingen kreditnota kilde funnet',
        noClientEmailNoInvoice:
          'Kunde mangler epost for å kunne sende faktura.',
        invoice: 'Faktura',
        creditnote: 'Kreditnota',
        creditNoteReason: 'Årsak',
        to: 'Til',
        from: 'Fra',
        subject: 'Emne',
        messageBody: 'Beskjed',
        notes: 'Merknader',
        attachment: 'Vedlegg',
        order: 'Ordre',
        date: 'Dato',
        paymentDate: 'Betalingsdato',
        dueDate: 'Forfallsdato',
        invoiceNumber: 'Faktura #',
        cc: 'Send en kopi til',
        deliveredTo: 'Levert',
        validateKidNumber: 'Valider KID',
        generateKidNumber: 'Lag KID',
        kidGenerateSuccess: 'Oppdatert',
        validKID: 'KID er gyldig',
        invalidKID: 'KID er ugyldig',
        emailTracking: {
          delivered: 'Levert',
          opened: 'Åpnet',
          clicked: 'Klikket',
          dropped: 'Droppet',
          bounced: 'Returnert',
          complained: 'Klaget',
          failed: 'Mislykket',
          recipient: 'Mottakeren',
          date: 'Dato',
          type: 'Type',
          device: 'Enhet',
        },
      },
      crediNoteReason: {
        title: 'Begrunnelse for kreditering',
      },
    },

    appointments: {
      index: {
        title: 'Avtale oversikt',
        futureFilter: 'Fra i dag',
        cancelled: 'Kansellert',
        completed: 'Fullført',
        created: 'Opprettet',
        ongoing: 'Pågående',
        noSlots: 'Ingen ledige tidspunkt for denne dagen.',
        freeSlot: 'Ledig tid!',
        nothingScheduled: 'Ingen avtaler.',
        exception: 'Unntak',
        displayWeekend: 'Vis helg',
        week: 'Uke',
      },
      create: {
        title: 'Legg til avtale',
      },
      edit: {
        title: 'Rediger time',
        editButton: 'Vis timebestillingen',
        destroyError: 'Beklager, men timen kunne ikke kanselleres.',
      },
    },

    shippingProviderAll: 'Alle leverandører',

    orderPickups: {
      title: 'Ordre logistikk',
      filter: {
        label: 'Filtrer etter',
      },
      tableHead: {
        order: 'Ordre',
        status: 'Status',
        customer: 'Kunde',
        shippingProvider: 'Fraktleverandør',
      },
      table: {
        number: 'Ordre #',
        createdAt: 'Opprettet',
        pickupDate: 'Hentedato',
        pickupBy: 'Hentet av',
        shippingProvider: 'Fraktleverandør',
        shippingDate: 'Forsendelsesdato',
        tracking: 'Sporing',
        openTracking: 'Åpne sporing',
        noTracking: 'Ingen sporing registrert ennå',
        deliveryDate: 'Leveringsdato',
        missing: 'Mangler',
        noData: 'Ingen tilgjengelige data',
      },
      index: {
        shippingStatuses: {
          all: 'All statuser',
          new: 'Ny',
          picked: 'Plukket',
          shipped: 'På vei',
          delivered: 'Levert',
          cancelled: 'Kansellert',
        },
      },
    },

    orders: {
      types: {
        all: 'Alle',
        product: 'Produkter',
        edi: 'EDI',
        appointment: 'Avtale',
        sale: 'Salg',
        return: 'Retur',
        wordpress: 'Drikkeriket',
        transfer: 'Overføring',
      },
      shippingConfirm: {
        title: 'Bekreft levering',
        unassignedProductWarning:
          'Det er fortsatt ufordelte produkter til pakken.',
        unassignedProductError:
          'Du må tilordne ALLE produktene for å fortsette.',
        manageDelivery: 'Administrer levering',
        shippingProviderRequired:
          'Fraktleverandør er påkrevd men ikke knyttet til varelaget.',
        addShippingProviderBtn:
          'Klikk her for å legge til fraktleverandør alternativer',
      },
      orderTable: {
        productErrorMessage: 'Produkt ikke funnet',
      },
      orderConfirm: {
        title: 'Bekreft ordre',
        znbTitle: 'Bekreft avgift',
        exciseWarningMessage:
          'Ordren inneholder drikkevare(r) som mangler avgiftsdata. Klikk på produktlinken for å oppdatere dataene før du går videre.',
        upsellMessage:
          'Du selger drikkevare(r) men har ikke avgiftsmodulen aktivert for enklere rapportering til skattemyndigheter og andre enheter. Ta kontakt med support@kundan.no for en gratis prøve!',
        clientType: 'Kundetype',
        excisable: 'Avgiftspliktig',
        nonExcisable: 'Ikke avgiftspliktig',
        exciseCode: 'Avgiftskode',
        exciseCheck: 'Avgiftsdata',
        paidExcise: 'Avgifter',
        paidExciseYes: 'BETALT',
        paidExciseNo: 'UBETALT',
        packagingCheck: 'Forpakning',
        table: {
          product: 'Produkt',
          excise: 'Avgiftsgrupper',
          exciseGroup: {
            beverage: 'Drikkevareavg.',
            packaging: 'Miljøavg.',
            basic: 'Grunnavg.',
          },
          bottleVolume: 'Volum (ℓ)',
          alcoholPercentage: 'Alkohol %',
        },
        orderConfirmNotification: 'Send en ordrebekreftelsesmelding til kunden',
      },
      orderWarehouse: {
        title: 'Oppdater lagersted',
      },
      orderInternalNote: {
        title: 'Notat',
      },
      purchaseReceive: {
        title: 'Mottatt innkjøp',
      },
      status: {
        undefined: 'Udefinert',
        created: 'Ny',
        Done: 'Ferdig',
        confirmed: 'Bekreftet',
        processed: 'Behandlet',
        received: 'Mottatt',
        completed: 'Fullført',
        invoiced: 'Faktura opprettet',
        invoiced_externally: 'Fakturert eksternt',
        bill_sent: 'Fakturert',
        credited: 'Kreditnotert',
        cancelled: 'Kansellert',
        shipping_confirmed: 'Ordre behandlet, under transport',
        invoiced_consolidated: 'Samlefakturert',
        waiting_autobilling: 'Venter autofaktura',
        picked: 'Ordre plukket',
        shipped: 'Ordre på vei til kunde',
        delivered: 'Ordre levert kunde',
        vipps_processing: 'Vipps behandling',
      },
      formTabs: {
        orderInformation: 'Ordre informasjon',
        deliveryNote: 'Leveringsinformasjon',
        edit: 'Rediger ordre',
      },
      orderLines: 'Ordrelinjer',
      index: {
        bulkMaxLimitExceededError:
          'Du har valgt for mange ordre! Vennligst reduser antall markerte ordre til maks',
        editTooltip: 'Rediger bestilling',
        deleteTooltip: 'Slett rekkefølge',
        title: 'Ordreoversikt',
        confirmDelete: 'Dette vil permanent slette ordren. Fortsett?',
        confirmDeleteTitle: 'Slett ordre',
        clientName: 'Kunde',
        orderType: 'Ordretype',
        activity: 'Aktivitet',
        start: 'Start',
        service: 'Tjeneste',
        confirmCancel: 'Dette vil avbryte ordren. Fortsett?',
        confirmCancelTitle: 'Kanseller ordre',
        status: 'Status',
        ediNumber: 'EDI nummer',
        deliveryDate: 'Leveringsdato',
        pickupDate: 'Plukkdato',
        client: 'Kunde',
        items: 'Varer',
        type: 'Type',
        qty: 'Antall',
        referenceNumber: 'Ordre referanse',
        createdDate: 'Ordredato',
      },
      table: {
        id: 'ID',
        name: 'Nummer',
        type: 'Type',
        status: 'Status',
        clientName: 'Kunde',
        totalValue: 'Pris',
        totalQuantity: 'Antall',
        createdDate: 'Ordredato',
        amountDue: 'Å betale',
        amountPaid: 'Betalt beløp',
      },
      create: {
        title: 'Opprett ordre',
      },
      edit: {
        orderReference: 'Ordrereferanse',
        returnOrderComplete: 'Returordre fullført',
        modalFormTitle: 'PRODUKT REDIGERING',
        title: 'Endre ordre',
        detailsLegend: 'Ordredetaljer',
        ediTitle: 'EDI Ordre',
        billsAndCreditNotes: 'Faktura og kreditnota fra denne ordren',
        bill: 'Faktura',
        creditNote: 'Kreditnota',
        customerDetails: 'Kundedetaljer',
        address: 'Adresse',
        successMessage: 'Oppdatert ordre!',
        orderProducttitle: 'Ordreprodukt',
        noProductWarning:
          'Ingen produkter er valgt. Klikk på "Legg til" for å legge til en produktlinje manuelt.',
        addProductButton: 'Opprett produkt',
        subtotal: 'Nettobeløp',
        discount: 'Rabatt',
        tax: 'Merverdiavgift',
        deposit: 'Pant',
        rounding: 'Øreavrunding',
        total: 'Totalbeløp',
        quantityError: 'Sum kan ikke være 0.',
        priceError: 'Prisen kan ikke være 0.',
        productErrorMessage: 'Produkt ikke funnet',
        orderType: 'Ordretype',
        client: 'Kunde',
        createBillButton: 'Opprett faktura',
        missingEdiDetails: 'EDI detaljer mangler, vennligst kontakt support.',
        cancelError: 'Ordre kunne ikke kanselleres.',
        cancelSuccess: 'Ordren(e) er kansellert.',
        returnSuccess: 'Ordren(e) har blitt returnert.',
        pleaseConfirmAllOrderProducts:
          'Vennligst bekreft antallet du kan levere før du går videre!',
        pleaseLinkTheSourceOrder:
          'Velg hvilken opprinnelig ordre denne ordren stammer fra. Hvis ukjent klikker du "Lag kreditnota".',
        quantityMustNotBeGreaterThanQuantityOrdered:
          'Antallet man bekrefter kan ikke overstige antallet bestilt',
        originalOrderItems: 'Original Order Items',
        orText: 'eller',
        roundInvoiceTotal: 'Aktiver øreavrunding på denne fakturaen',
        storeName: 'Butikknavn',
        storeAddress: 'Butikkadresse',
        requestedDeliveryDate: 'Ønsket leveringsdato',
        confirmedDeliveryDate: 'Bekreftet leveringsdato',
        pickupDate: 'Plukkdato',
        shippingProvider: 'Leveringstype',
        trackingNumber: 'Sporingsnummer',
        trackingUrlNotAvail: 'Sporingsadresse er ikke tilgjengelig',
        company: 'Selskap',
        name: 'Navn',
        appointmentDate: 'Avtaledato',
        appointmentTime: 'Avtaletid',
        appointmentDuration: 'Varighet',
        ediNumber: 'EDI nummer',
        linkedEdiNumber: 'Knyttet EDI nummer',
        orderNumber: 'Ordrenummer',
        orderDate: 'Ordredato',
        orderStatus: 'Ordrestatus',
        creditNotes: 'Kreditnota',
        minutes: 'Minutter',
        unconfirmed: 'Ubekreftet',
        warehouse: 'Lagersted',
        availableQty: 'På lager',
        nonBatch: 'Ingen batch',
        packageTitle: 'Administrer Pakker',
        pickup: 'Leveringsstatus',
        pickupBy: 'Henting av',
        deliveryDate: 'Leveringsdato',
        shippingDate: 'Forsendelsesdato',
        note: 'Merk',
        shippingOrder: 'Logistikk',
        shippingOrderText: 'Vis logistikk detaljer',
        referenceNumber: 'Ordre referanse',
        internalNote: 'Merk',
      },
      package: {
        newPackageCardTitle: 'Opprett pakke',
        UnassignedProductCardTitle: 'Ikke-tildelte produkter',
        created: 'Pakken ble opprettet',
        error: 'Feil ved oppretting av pakke',
        addProductToPackageTitle: 'Legg til produkter i pakken',
        editProductToPackageTitle: 'Rediger produkter i pakken',
        viewShippingLabel: 'Vis leveringsetikett',
        viewProductMixLabel: 'Vis pakkseddel etikett',
        editPackage: 'Rediger pakke',
        deletePackage: 'Slett pakken',
        btnAddProduct: 'Legg til produkt',
        addProduct: 'Legg til produkt',
        unassignedTable: {
          name: 'Produktnavn',
          gtin: 'GTIN',
          quantityConfirmed: 'Enheter bekreftet',
          quantityPacked: 'Enheter pakket',
          quantityUnpacked: 'Enheter ikke pakket',
        },
        createdPackage: {
          sscc: 'SSCC',
          unitType: 'Enhetstype',
          numberOfProducts: 'Antall produkter',
          totalQuantity: 'Totalt antall',
          totalNetWeight: 'Total nettovekt',
          totalGrossWeight: 'Total bruttovekt',
          totalStackWeight: 'Total topplast',
          products: 'Produkter',
          table: {
            gtin: 'GTIN',
            productName: 'Produktnavn',
            quantity: 'Mengde',
            weight: 'Vekt',
            bestBefore: 'Best før',
            maxTopLoad: 'Maks topplast',
            lotBatchNumber: 'Lot / Batch nummer',
            temperatureRequirement: 'Temperaturbehov',
          },
        },
      },
    },

    packageOrderProduct: {
      add: {
        error: 'Feil!',
        quantityExceedError:
          'Antall overskredet. Vennligst sjekk utpakket antall.',
        success: 'Vellykket lagt produktet til pakken.',
      },
      edit: {
        error: 'Feil!',
        quantityExceedError:
          'Antall overskredet. Vennligst sjekk utpakket antall.',
        success: 'Vellykket oppdatert produktet til pakken.',
      },
      destroy: {
        confirm: 'Fjern bestillingsprodukt fra pakke?',
        error: 'Feil!',
        success: 'Vellykket fjernet produktet til pakken.',
      },
    },

    package: {
      destroy: {
        confirm:
          'Alle bestillinger i pakken vil ikke bli tildelt. Bokser inni vil bli slettet. Slett pakken?.',
        error: 'Error!',
        success: 'Vellykket slettet pakken.',
      },
    },

    ediOrders: {
      index: {
        title: 'EDI ordreoversikt',
        cardHeader: 'Ordre # ',
        orderNumber: 'VP #',
        ediOrderTypeName: 'Type',
        created: 'Ny ordre, klar for behandling',
        confirmed: 'Ordre bekreftet, under behandling',
        processed: 'Ordre behandlet, under transport',
        shipped: 'Under transport',
        picked: 'Ordre plukket',
        received: 'Levering bekreftet mottatt',
        completed: 'Ordre fullført',
        pending: 'Venter',
        out_of_stock: 'Utsolgt',
        invoiced: 'Faktura opprettet',
        invoiced_externally: 'Fakturert eksternt',
        bill_sent: 'Fakturert',
        credited: 'Kreditnota opprettet',
        cancelled: 'Ordre kansellert',
        shipping_confirmed: 'Ordre behandlet, under transport',
        invoiced_consolidated: 'Samlefakturert',
        waiting_autobilling: 'Venter autofaktura',
        vipps_processing: 'Vipps behandling',
      },
      edit: {
        title: 'EDI ordreinformasjon',
        orderNumber: 'Ordrenummer',
        orderReference: 'Ordrereferanse',
        requestedDeliveryDate: 'Be om leveringsdato',
        noEdiOrderItemWarning: 'Ingen varer i denne ordren.',
        ediOrderType: 'EDI ordretype',
        partyId: 'Butikk ID',
        storeName: 'Butikknavn',
        deliveryDate: 'Leveringsdato',
        ediOrderStatus: 'Status',
        invalidDeliveryDate: 'Vennligst velg en gyldig leveringsdato.',
        confirmSuccess: 'Ordre bekreftet.',
        vippsProcessingTitle: 'Vennligst vent',
        vippsProcessing: 'Bestillingen behandler Vipps-betalingen, vennligst last inn siden igjen etter noen minutter.',
        confirmError: 'En feil oppstod i ordren, vennligst prøv igjen senere.',
        invoiceSuccess: 'Faktura opprettet.',
        invoiceSentSuccess: 'Faktura sendt.',
        creditNoteSentSuccess: 'Kreditnota sendt.',
        invoiceError: 'En feil oppstod i ordren, vennligst prøv igjen senere.',
        processSuccess: 'Ordre behandlet.',
        processError: 'En feil oppstod i ordren, vennligst prøv igjen senere.',
        pleaseConfirmAllOrders: 'Vennligst bekreft alle varer i denne ordren.',
        cancelSuccess: 'Ordre kansellert.',
        returnSuccess: 'Ordren(e) har blitt returnert.',
        confirmCancel: 'Er du sikker på at du ønsker å kansellere denne ordren?',
        cancelError: 'En feil oppstod i ordren, vennligst prøv igjen senere.',
        ediOrderSourceWineMonopolyOrderReference: 'Opprinnelig ordrereferanse',
        orderDate: 'Ordredato',
        warehouseChanged: 'Lagersted endret',
      },
    },

    settings: {
      generalSettings: 'Generelle Innstillinger',
      productDisplay: 'Detaljert produktvisning',
      newField: 'Nytt felt',
      edi: {
        defaultEdiProductGroupName: 'Standard EDI produktgruppe navn',
        defaultEdiClientGroupName: 'Standard EDI kundegruppe navn',
        defaultEdiClientName: 'Standard EDI kundenavn',
        defaultEdiClientContactPhoneNumber: 'Standard EDI kundetelefonnummer',
        defaultEdiClientAddressStreetName: 'Standard EDI kunde gatenavn',
        defaultEdiClientAddressCityId: 'Standard EDI kunde by',
        defaultEdiClientAddressZipCode: 'Standard EDI kunde postnummer',
        defaultEdiTaxPercentage: 'Standard EDI MVA prosent',
        ediOrderNumberDefault: 'Standard EDI ordrenummer',
        ediOrderDeliveryNoteNumberDefault: 'Standard EDI pakkseddel',
      },
    },
  },

  layouts: {
    header: {
      individual: 'Enkeltpersonforetak (ENK)',
      company: 'Aksjeselskap (AS)',
      viewClient: 'Vis kunde',
    },

    sidebar: {
      storeSynced: 'Aktiv nettbutikk',
      dashboard: 'Skrivebord',
      profile: 'Profil',
      account: 'Konto',
      address: 'Adresse',
      contact: 'Kontakt',
      settings: 'Instillinger',
      clientGroups: 'Kundegrupper',
      clients: 'Kunder',
      clientGroup: 'Kundegrupper',
      clientAgreements: 'Kundeavtaler',
      newAgreement: 'Ny avtale',
      importAgreement: 'Importer avtale',
      newOrders: 'Nye',
      today: 'I dag',
      upcoming: 'Kommende',
      members: 'Brukere',
      calendar: 'Kalender',
      pending: 'I påvente av',
      inTransit: 'På vei',
      confirmed: 'Bekreftet',
      complete: 'Fullført',
      recieved: 'Mottatt',
      invoiced: 'Fakturert',
      credited: 'Kreditert',
      cancelled: 'Kansellert',
      outOfStock: 'Utsolgt',
      done: 'Ferdig',
      latest: 'Siste',
      active: 'Aktive',
      inActive: 'Inaktive',
      pastMonth: 'Siste måned',
      all: 'Alle',
      productGroups: 'Produktgrupper',
      production: 'Produksjon',
      products: 'Produkter',
      services: 'Tjenester',
      wordpress: 'Wordpress',
      orders: 'Ordre',
      booking: 'BOOKING',
      ediOrders: 'EDI ordre',
      orderFilter: 'Ordrestatus',
      logout: 'Logg ut',
      publicProfile: 'Offentlig',
      appointments: 'Avtaler',
      bills: 'Regnskap',
      edi: 'EDI',
      allOrders: 'Alle ordre',
      reports: 'Rapport',
      newsletter: 'Nyhetsbrev',
      subscriberList: 'Lister',
      orderedPastWeek: 'Bestilt sist uke',
      orderedPastMonth: 'Bestilt sist måned',
      neverOrdered: 'Uten ordre',
      emptyOrders: 'Uten ordre',
      switchToOrganization: 'Bytt til',
      supplier: 'Leverandør',
      warehouse: 'Lagersted',
      unitOfMeasure: 'Unit of Measures',
      stock: 'Lager',
      inventory: 'Lager',
      billExport: 'Eksport av data',
      modules: 'Moduler',
      deactivated: 'Deactivated',
      notInvoiced: 'Ikke fakturert',
      orderPickups: {
        title: 'Orderplukk',
        viewAll: 'Vis alle',
      },
    },
  },
  pricingAgreements: {
    title: 'Prisavtaler',
    titleWithCount: 'Prisavtaler ({count})',
    newAgreement: 'Ny avtale',
    createOne: 'Opprett en',
    importFromTemplate: 'Importer fra mal',
    importFromTemplateLink: 'importer fra Excel/CSV-mal',
    noAgreements: 'Ingen prisavtaler.',
    customer: 'Kunde',
    selectCustomer: 'Velg kunde',
    agreementName: 'Avtalenavn',
    agreementNamePlaceholder: 'Valgfritt; bruker malens navn hvis tom',
    file: 'Fil',
    downloadTemplate: 'Last ned mal (XLSX)',
    chooseFile: 'Velg fil (CSV eller XLSX)',
    cancel: 'Avbryt',
    import: 'Importer',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    valid: 'Gyldig',
    lineCount: '{n} linje(r)',
    newPricingAgreement: 'Ny prisavtale',
    orImportLink: 'Eller',
    name: 'Navn',
    namePlaceholder: 'f.eks. Sesongavtale',
    validFrom: 'Gyldig fra',
    validTo: 'Gyldig til',
    from: 'Fra',
    to: 'Til',
    save: 'Lagre',
    createButton: 'Opprett',
    back: 'Tilbake',
    editPricingAgreement: 'Rediger prisavtale',
    product: 'Produkt',
    products: 'Produkter',
    addProduct: 'Legg til produkt',
    searchProductByName: 'Søk produkt etter navn',
    minQty: 'Min. antall',
    discountLabel: 'Rabatt',
    discountPercent: 'Rabatt %',
    discountAmount: 'Rabattbeløp',
    discountAmt: 'Rabattbeløp',
    perUnit: 'Per enhet',
    comment: 'Kommentar',
    noProductsInAgreement: 'Ingen produkter i denne avtalen.',
    productFallback: 'Produkt #',
    confirm: 'Bekreft',
    deleteProductConfirm: 'Slette dette produktet fra avtalen?',
    agreementUpdated: 'Avtale oppdatert',
    errorUpdatingAgreement: 'Feil ved oppdatering av avtale',
    productAndMinQtyRequired: 'Produkt og min. antall må fylles ut',
    setDiscountOrAmount: 'Angi enten Rabatt % eller Rabattbeløp',
    productAdded: 'Produkt lagt til',
    errorAddingProduct: 'Feil ved tillegg av produkt',
    minQtyAtLeast1: 'Min. antall må være minst 1',
    productUpdated: 'Produkt oppdatert',
    errorUpdatingProduct: 'Feil ved oppdatering av produkt',
    productRemoved: 'Produkt fjernet',
    errorRemovingProduct: 'Feil ved fjerning av produkt',
    importCreated: 'Avtale opprettet. {count} linje(r) lagt til.',
    importSkipped: '{count} rad(er) hoppet over.',
    importFailed: 'Import feilet',
    unmatchedTitle: 'Koble til produkter (mangler EPD/GTIN)',
    unmatchedIntro: 'Produkter uten EPD/GTIN eller uten rabatt % vises her. Velg produkt om nødvendig, fyll inn rabatt %, deretter klikk Legg til.',
    importedName: 'Importert navn',
    addLine: 'Legg til',
    lineAdded: 'Linje lagt til',
    closeAndViewAgreement: 'Lukk og vis avtale',
    needToMatch: '{count} produkt(er) trenger tilkobling',
    searchProductsInAgreement: 'Søk produkter',
    noProductsMatchSearch: 'Ingen produkter matcher søket.',
    searchAgreements: 'Søk avtaler',
    noAgreementsMatchSearch: 'Ingen avtaler matcher søk eller filter.',
    deleteAgreementConfirm: 'Slette denne prisavtalen? Dette kan ikke angres.',
    customerHasAgreementConfirm: 'Denne kunden har allerede en prisavtale. Vil du fortsette med import?',
    agreementDeleted: 'Prisavtale slettet',
    errorDeletingAgreement: 'Feil ved sletting av prisavtale',
    errorCreatingAgreement: 'Feil ved opprettelse av avtale',
    validationNameAlreadyExists: 'Denne kunden har allerede en prisavtale med dette navnet.',
    lines: 'Linjer',
    actions: 'Handlinger',
    sortNameAsc: 'Navn (A → Z)',
    sortNameDesc: 'Navn (Z → A)',
    sortCustomerAsc: 'Kunde (A → Z)',
    sortCustomerDesc: 'Kunde (Z → A)',
    sortValidFromDesc: 'Gyldig fra (nyeste)',
    sortValidFromAsc: 'Gyldig fra (eldste)',
    sortProductNameAsc: 'Navn (A til Z)',
    sortProductNameDesc: 'Navn (Z til A)',
    sortMinQtyAsc: 'Min. antall (lav til høy)',
    sortMinQtyDesc: 'Min. antall (høy til lav)',
  },
  button: {
    search: 'Søk',
    createReminder: 'Lag påminnelse',
    creditNoteReason: 'Angi Årsak for kreditnota',
    glnLookup: 'Hent data FRA GLN',
    markAs: 'Merk som',
    pending: 'Avventer',
    updateDraft: 'Oppdater utkastet',
    updatePending: 'Oppdater Venter',
    complete: 'Ferdigstill',
    createReturnOrder: 'Opprett returordre',
    addClient: 'Legg til ny kunde',
    addClientGroup: 'Legg til kundegruppe',
    addBookingOrder: 'Legg til bestillingsordre',
    addEdiOrder: 'Legg til Edi-ordre',
    addCampaign: 'Legg til kampanje',
    addSubscriberList: 'Lag liste',
    enter: 'Logg inn',
    expand: 'Utvid',
    register: 'Registrer',
    next: 'Neste',
    getStarted: 'Fullfør registreringen',
    save: 'Lagre',
    update: 'Oppdater',
    view: 'Vis',
    clear: 'Klar',
    confirm: 'Bekreft',
    shippingConfirm: 'Bekreft levering',
    purcahseReceive: 'Mottatt innkjøp',
    process: 'Bekreft levering',
    proceed: 'Bekreft levering',
    createInvoice: 'Lag faktura',
    invoiceExternally: 'Merk som: Fakturert eksternt',
    updateInvoice: 'Oppdater faktura',
    saveDraft: 'Lagre kladd',
    markAsCleared: 'Merk som fullført',
    createCreditNote: 'Lag kreditnota',
    showPrintableDeliveryNote: 'Vis pakkseddel',
    downloadPrintableDeliveryNote: 'Last ned pakkseddel',
    login: 'Logg inn',
    send: 'Send',
    resend: 'Send igjen',
    sendTest: 'Send test epost',
    cancel: 'Avbryt',
    cancelEDIOrder: 'Kanseller ordre',
    cancelOrder: 'Kanseller ordre',
    cancelOrders: 'Kanseller valgte ordre',
    delete: 'Slett',
    deleteProduct: 'Slett produkt',
    deleteClient: 'Slett kunde',
    downloadImport: 'Last ned',
    yes: 'Ja',
    no: 'Nei',
    skip: 'Skip',
    registerCRM: 'Prøv kundesystemet',
    registerInvoicing: 'Prøv faktura',
    registerBooking: 'Prøv booking',
    registerEDI: 'Prøv EDI',
    editText: 'Rediger mal',
    testEmail: 'Test',
    testEmailTitle: 'Send en testfaktura til e-posten din',
    add: 'Legg til',
    edit: 'Rediger',
    book: 'Bestill',
    close: 'Lukk',
    markAsDraft: 'Utkast',
    markAsDone: 'Ta mottak',
    merge: 'Slå sammen produkter',
    confirmAsOrder: 'Bekreft som bestilt',
    import: 'Import',
    adjustment: {
      completeAdjustment: 'Fullfør lagerjustering',
      exportAdjustmentProducts: 'Last ned produkter',
    },
    stockCount: {
      completeStockCount: 'Fullfør lagertelling',
    },
    export: 'Eksporter data',
    dragAndDropImport: 'Dra og slipp filer her...',
    subscribe: 'Abonnere',
    unsubscribe: 'Deaktiver',
    syncData: 'Synkroniser data',
    startSync: 'Start synkronisering',
    confirmSync: 'Bekreft synkronisering',
    syncNow: 'Synkroniser nå',
    continue: 'Fortsett',
    fetchFromVmp: 'Hent data fra Vinmonopolet',
    setMinimumStock: 'Sett minimumsbeholdning',
    destroy: 'Destruer',
    unsubscribeAll: 'Avslutt abonnementet på alle',
    subscribeAll: 'Abonner på alle',
    goToEditPage: 'Gå til Rediger side',
    reload: 'Oppdater',
    bulkPriceUpdate: 'Bulk prisoppdatering',
  },

  search: {
    title: {
      placeholder: 'Søk',
    },
  },

  sort: {
    month: 'Måned',
    last: 'Siste',
    older: 'Eldre',
    newer: 'Nyere',
    lastName: 'Etternavn',
    name: 'Navn',
    title: 'Sorter etter',
    placeholder: 'Velg',
    bestPaying: 'Beste kunde',
    worstPaying: 'Dårligste kunde',
    biggestDebtors: 'Mest utestående',
    clientsCountDesc: 'Flest kunder',
    clientsCountAsc: 'Færrest kunder',
    lastWeek: 'Forrige uke',
    last14Days: 'Siste 14 dager',
    last21Days: 'Siste 21 dager',
    lastMonth: 'Forrige måned',
  },

  listType: {
    all: 'Alle ordre',
    order: 'Andre ordre',
    edi: 'EDI ordre',
  },

  messages: {
    warning: 'Advarsel',
    newer: 'Nyere',
    lastName: 'Etternavn',
  },

  orderActions: {
    select: {
      label: 'Velg handling',
      placeholder: 'Handling',
    },
    confirmOrder: 'Bekreft ordre',
    confirmShipping: 'Bekreft sending',
    confirmOrderAndShipping: 'Bekreft ordre & sending',
    dowloadDeliverySlip: 'Last ned pakkseddel',
    createInvoice: 'Opprett faktura',
    cancelOrder: 'Kanseller ordre',
  },

  productActions: {
    select: {
      label: 'Velg handling',
      placeholder: 'Handling',
    },
    activateProduct: 'Aktiver produktet',
    deactivateProduct: 'Deaktiver produkt',
    syncToWoo: 'Synkroniser til Nettbutikk',
  },

  clientActions: {
    select: {
      label: 'Velg handling',
      placeholder: 'Handling',
    },
    isSubClient: 'Er underklient',
    isProducer: 'er produsent',
    activateClient: 'Aktiver klient',
    deactivateClient: 'Deaktiver klient',
  },

  billActions: {
    markBilledAsPaid: 'Merk faktura som betalt',
    downloadInvoicePdf: 'Last ned faktura PDF',
  },

  form: {
    batch: {
      transferDate: {
        placeholder: '',
        label: 'Dato',
      },
      productName: {
        placeholder: '',
        label: 'Produkter',
      },
      qty: {
        placeholder: '',
        label: 'Mengde',
      },
      warehouse: {
        placeholder: '',
        label: 'Varelager',
      },
    },
    bundleProductPreview: {
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      price: {
        label: 'Pris',
        placeholder: 'Pris',
      },
    },
    billReminderModal: {
      title: 'Lag påminnelse',
      reminderType: {
        label: 'Type påminnelse',
        placeholder: '',
      },
      feeAmount: {
        label: 'Gebyrbeløp',
        placeholder: '',
      },
      penaltyFee: {
        label: 'Straffegebyr',
        placeholder: '',
        options: {
          withFees: 'Med gebyrer',
          withoutFees: 'Uten gebyrer',
        },
      },
      notes: {
        label: 'Notater',
        placeholder: 'Notater',
      },
    },
    license: {
      organizationNumber: {
        label: 'Organisasjonsnummer',
        placeholder: '',
      },
      licenseTypeId: {
        label: 'Lisenstype',
        placeholder: '',
      },
      licensePermitTypeId: {
        label: 'Tillatelsestype',
        placeholder: '',
      },
      licenseGroupIds: {
        label: 'Varegrupper',
        placeholder: '',
      },
      validFrom: {
        label: 'Gyldig fra',
        placeholder: '',
      },
      validTo: {
        label: 'Gyldig til',
        placeholder: '',
      },
      licenseFile: {
        label: 'Lisensfil',
        placeholder: '',
      },
      licenseNumber: {
        label: 'Lisensnummer',
        placeholder: '',
      },
      name: {
        label: 'Navn',
        placeholder: '',
      },
      streetName: {
        label: 'Adresse',
        placeholder: '',
      },
      postalCode: {
        label: 'Postnummer',
        placeholder: '',
      },
      city: {
        label: 'Poststed',
        placeholder: '',
      },
      municipality: {
        label: 'Kommune',
        placeholder: '',
      },
      municipalityNumber: {
        label: 'Kommunenummer',
        placeholder: '',
      },
    },
    bulkSendTurnOver: {
      from: {
        label: 'Fra',
        placeholder: 'Fra',
      },
      subject: {
        label: 'Emne',
        placeholder: 'Emne',
        preset: 'Omsetningsoppgave',
      },
      message: {
        label: 'Beskjed',
        placeholder: 'Beskjed',
        preset: 'Se vedlegg for omsetningsoppgaven for',
      },
    },
    vmpSync: {
      syncFields: {
        placeholder: 'Velg felt å oppdatere',
        label: 'Velg felt å oppdatere',
      },
    },
    wooCredentialsModal: {
      routesTitle: 'Følgende adresser må settes i Woocommerce webhooks',
      title: 'Woocommerce api (Fra Kundan til Woocommerce)',
      websiteUrl: {
        placeholder: 'Nettadresse',
        label: 'Nettadresse',
      },
      apiKey: {
        placeholder: 'API nøkkel',
        label: 'API nøkkel',
      },
      secretKey: {
        placeholder: 'Sikkerhetsnøkkel',
        label: 'Sikkerhetsnøkkel',
      },
      language: {
        placeholder: '',
        label: 'Språk',
      },
      productAttributes: {
        placeholder: '',
        label: 'Produktegenskaper',
      },
      syncProductGroup: {
        placeholder: '',
        label: 'Synkroniser produkttypegruppe/undergruppe',
      },
      syncSelectedProductsOnly: {
        placeholder: '',
        label: 'Synkroniser kun utvalgte produkter',
      },
      secret: {
        title: 'Woocommerce webhooks (Fra Woocommerce til Kundan)',
        apiOrderCreated: {
          placeholder: 'Skriv inn hemmelighet',
          label: 'Ordre opprettet',
        },
        apiOrderUpdated: {
          placeholder: 'Skriv inn hemmelighet',
          label: 'Ordre oppdatert',
        },
        apiOrderDeleted: {
          placeholder: 'Skriv inn hemmelighet',
          label: 'Ordre slettet',
        },
        apiCustomerCreated: {
          placeholder: 'Skriv inn hemmelighet',
          label: 'Kunde opprettet',
        },
        apiCustomerUpdated: {
          placeholder: 'Skriv inn hemmelighet',
          label: 'Kunde oppdatert',
        },
        apiCustomerDeleted: {
          placeholder: 'Skriv inn hemmelighet',
          label: 'Kunde slettet',
        },
        apiProductCreated: {
          placeholder: 'Skriv inn hemmelighet',
          label: 'Produkt opprettet',
        },
        apiProductUpdated: {
          placeholder: 'Skriv inn hemmelighet',
          label: 'Produkt oppdatert',
        },
        apiProductDeleted: {
          placeholder: 'Skriv inn hemmelighet',
          label: 'Produkt slettet',
        },
      },
    },
    wordpressCredentialsModal: {
      title: 'Wordpress api',
      kundanWordpressPluginToken: 'Kundan Wordpress Plugin Token',
      websiteUrl: {
        placeholder: 'Website url',
        label: 'Website url',
      },
    },
    orderInternalNote: {
      internalNote: {
        placeholder: 'Internal note',
        label: 'Internal note',
      },
    },
    orderWarehouse: {
      warehouseId: {
        placeholder: 'Velg lagersted',
        label: 'Lagersted',
      },
    },
    module: {
      email: {
        placeholder: 'Enter Email',
        label: 'Email',
      },
      password: {
        placeholder: 'Enter password',
        label: 'Password',
      },
      consumer_token: {
        placeholder: 'Enter Consumer Token',
        label: 'Consumer Token',
      },
      employee_token: {
        placeholder: 'Enter Employee Token',
        label: 'Employee Token',
      },
      fiken_email: {
        placeholder: 'Skriv inn epost',
        label: 'Epost',
      },
      fiken_password: {
        placeholder: 'Skriv inn passord',
        label: 'Passord',
      },
      poweroffice_application_key: {
        placeholder: 'Skriv inn applikasjonsnøkkel',
        label: 'Applikasjonsnøkkel',
      },
      poweroffice_client_key: {
        placeholder: 'Skriv inn klientnøkkel',
        label: 'Klientnøkkel',
      },
      poweroffice_company_slug: {
        placeholder: 'Skriv inn bedrifts-slug',
        label: 'Bedrifts-slug',
      },
      poweroffice_app_key: {
        placeholder: 'Skriv inn app-nøkkel',
        label: 'App-nøkkel',
      },
      poweroffice_integration_type: {
        placeholder: 'Velg type integrasjon',
        label: 'Integrasjonstype',
      },
      tripletex_consumer_token: {
        placeholder: 'Enter Consumer Token',
        label: 'Consumer Token',
      },
      tripletex_employee_token: {
        placeholder: 'Enter Employee Token',
        label: 'Employee Token',
      },
      preferred_invoice_sender: {
        placeholder: 'Select Preferred Invoice Sender',
        label: 'Send Invoice From',
      },
      preferred_send_type: {
        placeholder: 'Select Preferred Send Type',
        label: 'Send Type',
      },
      vmp_wholesaler_id: {
        placeholder: 'Skriv inn VMP grossist ID',
        label: 'VMP Grossist ID',
      },
      public_marketplace: {
        placeholder: 'Aktiver',
        label: 'Offentlig markedsplass',
      },
      marketplaces_enabled: {
        placeholder: '',
        label: 'Partnerbutikk',
      },
      ongoing_warehouse_warehouse: {
        placeholder: '',
        label: 'Ongoing varelager ID',
      },
      ongoing_warehouse_username: {
        placeholder: '',
        label: 'Ongoing brukernavn',
      },
      ongoing_warehouse_password: {
        placeholder: '',
        label: 'Ongoing passord',
      },
      ongoing_warehouse_goods_owner_id: {
        placeholder: '',
        label: 'Ongoing goods owner ID',
      },
    },
    shippingConfirm: {
      shippingProviderId: {
        placeholder: 'Fraktleverandør',
        label: 'Fraktleverandør',
      },
      shippingDate: {
        placeholder: 'Leveringsdato',
        label: 'Leveringsdato',
      },
      importantReminder: {
        placeholder: 'Viktig påminnelse',
        label: 'Viktig påminnelse',
      },
    },
    orderConfirm: {
      confirmDate: {
        placeholder: 'Dato bekreftet',
        label: 'Dato bekreftet',
      },
      deliveryDate: {
        placeholder: 'Leveringsdato',
        label: 'Leveringsdato',
      },
      warehouseId: {
        placeholder: 'Velg lagersted',
        label: 'Lagersted',
      },
      shippingProviderId: {
        placeholder: 'Fraktleverandør',
        label: 'Fraktleverandør',
      },
      shippingDate: {
        placeholder: 'Leveringsdato',
        label: 'Leveringsdato',
      },
    },
    purchaseReceive: {
      receiveDate: {
        placeholder: 'Dato mottatt',
        label: 'Dato mottatt',
      },
    },
    registerBillPayment: {
      paymentDate: {
        placeholder: 'Betalingsdato',
        label: 'Betalingsdato',
      },
      paymentInFull: {
        placeholder: 'Ja',
        label: 'Betalt i sin helhet?',
      },
      paymentAmount: {
        placeholder: 'Betalingsbeløp',
        label: 'Betalingsbeløp',
      },
    },
    billConfirm: {
      paymentDateOption: {
        placeholder: 'Velg betalingsdato',
        label: 'Velg betalingsdato',
      },
      paymentDate: {
        placeholder: 'Betalingsdato',
        label: 'Betalingsdato',
      },
      paymentMethod: {
        label: 'Betalingsmetoder',
        placeholder: 'Betalingsmetoder',
      },
    },
    registerCreditNoteReason: {
      creditNoteReasonId: {
        label: 'Årsak til krediteringen',
        placeholder: 'Velg en begrunnelse',
      },
      reasonNote: {
        label: 'Beskrivelse',
        placeholder: 'Beskrivelse',
      },
      additionalDescription: {
        label: 'Tilleggsinformasjon',
        placeholder: 'Skriv inn tilleggsinfo (ikke nødvendig)',
      },
      systemAttributes: {
        label: '',
        placeholder: '',
      },
    },
    billPaymentModal: {
      title: 'Faktura betaling',
      amountDue: 'Beløp som forfaller',
      isFullyPaid: {
        label: 'Fullt betalt',
        placeholder: 'Fullt betalt',
      },
      paymentMethod: {
        label: 'Betalingsmåte',
        placeholder: 'Betalingsmåte',
      },
      amountPaid: {
        label: 'Betalt beløp',
        placeholder: 'Betalt beløp',
      },
      paymentDate: {
        label: 'Betalingsdato',
        placeholder: 'Betalingsdato',
      },
      reference: {
        label: 'Referanse',
        placeholder: 'Referanse',
      },
      internalNote: {
        label: 'Internt notat',
        placeholder: 'Internt notat',
      },
    },
    register: {
      businessRegistrationNumber: {
        label: 'Organisasjonsnummer',
        placeholder: 'Skriv inn organisasjonsnummer',
      },
      firstName: {
        placeholder: 'Fornavn',
      },
      lastName: {
        placeholder: 'Etternavn',
      },
      email: {
        label: 'Epost',
        placeholder: 'Hva er din epost?',
      },
      password: {
        placeholder: 'Passord',
      },
      passwordConfirmation: {
        placeholder: 'Gjenta passord',
      },
      planId: {
        placeholder: 'Plan',
      },
      organizationTypeId: {
        placeholder: 'Organisasjonstype',
      },
      businessName: {
        placeholder: 'Hva er ditt selskapsnavn?',
      },
      mobile: {
        placeholder: 'Tlf / mobilnummer',
      },
      address: {
        placeholder: 'Adresse',
      },
      postalCode: {
        placeholder: 'Postnummer',
      },
      city: {
        placeholder: 'Poststed',
      },
      country: {
        placeholder: 'Land',
      },
      isVatRegistered: {
        placeholder: 'MVA registrert',
      },
      isRegisteredBusinessEnterprise: {
        placeholder: 'Registrert i foretaksregisteret',
      },
      tosAccepted: {
        placeholder:
          'Jeg har lest og aksepterer <a href="http://www.kundan.no/regler/">regler og vilkårene</a>',
      },
      marketingAllowed: {
        placeholder:
          'Jeg ønsker å motta nyheter, tilbud og annen relevant info fra Kundan AS via epost. NB! Dine opplysninger deles aldri med noen tredjepart, og du kan velge å melde deg av når som helst.',
      },
    },

    supplier: {
      basicInformation: 'Grunnleggende informasjon',
      contactInformation: 'Kontakt informasjon',
      AddressInformation: 'Adresse informasjon',
      code: {
        placeholder: 'Kode',
        label: 'Leverandørkode',
      },
      name: {
        placeholder: 'Navn',
        label: 'Leverandørnavn',
      },
      email: {
        placeholder: 'Epost',
        label: 'Epost',
      },
      phonenumber: {
        placeholder: 'Telefon',
        label: 'Telefon',
      },
      mobilenumber: {
        placeholder: 'Mobil',
        label: 'Mobil',
      },
      streetName1: {
        placeholder: 'Adresse',
        label: 'Adresse',
      },
      streetName2: {
        placeholder: 'Adresse 2',
        label: 'Adresse 2',
      },
      city: {
        placeholder: 'Postested',
        label: 'Poststed',
      },
      countryId: {
        placeholder: 'Land',
        label: 'Land',
      },
      postalCode: {
        placeholder: 'Postkode',
        label: 'Postkode',
      },
    },

    warehouse: {
      basicInformation: 'Grunnleggende informasjon',
      contactInformation: 'Kontakt',
      addressInformation: 'Adresse',
      warehouseInformation: 'Lager',
      noData: 'Ingen data',
      location: {
        placeholder: 'Sted',
        label: 'Lagerplassering',
      },
      name: {
        placeholder: 'Navn',
        label: 'Lagernavn',
      },
      isActive: {
        placeholder: '',
        label: 'Active',
      },
      typeName: {
        placeholder: 'Lagertype',
        label: 'Lagertype',
      },
      isBonded: {
        label: 'Tollfritt lager',
        placeholder: 'Aktiver',
      },
      shippingProviders: {
        label: 'Fraktleverandør alternativer',
        placeholder: '',
      },
      contact: {
        firstName: {
          label: 'Fornavn',
          placeholder: '',
        },
        lastName: {
          label: 'Etternavn',
          placeholder: '',
        },
        email: {
          label: 'Epostadresse',
          placeholder: '',
        },
        phoneNumber: {
          label: 'Telefonnummer',
          placeholder: '',
        },
      },
      address: {
        streetName1: {
          label: 'Gatenavn',
          placeholder: '',
        },
        streetName2: {
          label: 'Gatenavn 2',
          placeholder: '',
        },
        postalCode: {
          label: 'Postnummer',
          placeholder: '',
        },
        city: {
          label: 'By',
          placeholder: '',
        },
        countryId: {
          label: 'Land',
          placeholder: '',
        },
      },
      productTab: {
        modal: {
          title: 'Lagerbeholdning',
          minimumStockLevel: {
            label: 'Minimum lagernivå',
            placeholder: 'Minimum lagernivå',
          },
        },
      },
    },

    unitOfMeasure: {
      basicInformation: 'Basic Information',
      code: {
        placeholder: 'Code',
        label: 'Unit of Measure Code',
      },
      name: {
        placeholder: 'Name',
        label: 'Unit of Measure Name',
      },
    },

    stock: {
      basicInformation: 'Generell Informasjon',
      warehouseId: {
        placeholder: 'Lagersted',
        label: 'Lagersted',
      },
      name: {
        placeholder: 'Navn på lagertelling',
        label: 'Navn på lagertelling',
      },
      descriptions: {
        placeholder: 'Skriv inn ønsket beskrivelse',
        label: 'Beskrivelse',
      },
      transactionDate: {
        placeholder: '',
        label: 'Transaksjonsdato',
      },
    },

    adjustment: {
      basicInformation: 'Generell Informasjon',
      stockId: {
        placeholder: 'Lagertelling',
        label: 'Lagertelling',
      },
      reason: {
        placeholder: 'Årsak',
        label: 'Årsak',
      },
      warehouseId: {
        placeholder: 'Lagersted',
        label: 'Lagersted',
      },
      adjustmentTypeId: {
        placeholder: 'Justeringstype',
        label: 'Justeringstype',
      },
      adjustmentTypeList: {
        adjustment: 'Lagerjustering',
        wastage: 'Manko (avg.kode "99")',
        destruction: 'Tilintetgjort (avg.kode "40")',
      },
      adjustmentStatus: {
        completed: 'Fullført',
        draft: 'Kladd',
        pending: 'Ventende',
        sent: 'Sendte',
        cancelled: 'Avbrutt',
        deviation: 'Avvik / feilet',
      },
    },

    purchase: {
      basicInformation: 'Generell Informasjon',
      producerId: {
        placeholder: 'Produsent',
        label: 'Produsent',
      },
      supplierId: {
        placeholder: 'Velg leverandør',
        label: 'Leverandør',
      },
      comments: {
        placeholder: 'Kommentar',
        label: 'Kommentar',
      },
      name: {
        placeholder: 'Navn',
        label: 'Navn',
      },
      purchaseNumber: {
        placeholder: 'Innkjøpsreferanse',
        label: 'Innkjøpsreferanse',
      },
      warehouseId: {
        placeholder: 'Velg lagersted',
        label: 'Lagersted',
      },
      status: {
        placeholder: 'Velg status',
        label: 'Status',
      },
      expectedDeliveryDate: {
        placeholder: 'Velg dato',
        label: 'Forventet leveringsdato',
      },
      edit: {
        sendPurchaseSuccess: 'Kjøp ble sendt.',
        sendPurchaseError: 'Det oppstod en feil med kjøpet. Prøv igjen senere.',
      },
    },

    transfer: {
      basicInformation: 'Overføringsdetaljer',
      date: {
        placeholder: 'Overføringdato',
        label: 'Overføringdato',
      },
      transferType: {
        placeholder: 'Overføringstype',
        label: 'Overføringstype',
      },
      fromWarehouseId: {
        placeholder: 'Fra lager',
        label: 'Fra lager',
      },
      toWarehouseId: {
        placeholder: 'Til lager',
        label: 'Til lager',
      },
      batchId: {
        placeholder: 'Velg batch',
        label: 'Velg batch',
      },
      comments: {
        placeholder: 'Kommentar',
        label: 'Kommentar',
      },
      products: {
        placeholder: 'Velg et produkt',
        label: 'Produkter',
      },
      batches: {
        placeholder: 'Velg en batch',
        label: 'Batcher',
      },
      productId: {
        label: 'Produktnavn',
        placeholder: 'Velg produkt',
      },
      qty: {
        label: 'Antall',
        placeholder: 'Antall',
      },
    },

    personalInfo: {
      phoneNumber: {
        placeholder: 'Telefonnummer',
      },
      streetName: {
        placeholder: 'Adresse',
      },
      secondStreetName: {
        placeholder: 'Adresse 2',
      },
      postalCode: {
        placeholder: 'Postnummer',
      },
      countryId: {
        placeholder: 'Velg land',
      },
      cityName: {
        placeholder: 'By',
      },
    },

    login: {
      email: {
        placeholder: 'Epost',
      },
      password: {
        placeholder: 'Passord',
      },
    },

    resetPassword: {
      email: {
        placeholder: 'Skriv din epost',
      },
    },

    twoFactorVerification: {
      code: {
        label: 'Skriv inn kode',
        placeholder: 'Skriv inn kode',
      },
      verifyButton: {
        label: 'Bekrefte',
      },
      resendButton: {
        label: 'Sende',
      },
    },

    accountInformation: {
      email: {
        label: 'Epost',
        placeholder: 'Epost',
      },
      firstName: {
        label: 'Fornavn',
        placeholder: 'Fornavn',
      },
      lastName: {
        label: 'Etternavn',
        placeholder: 'Etternavn',
      },
      userEmail: {
        label: 'Epost',
        placeholder: 'Epost',
      },
      userFirstName: {
        label: 'Fornavn',
        placeholder: 'Fornavn',
      },
      userLastName: {
        label: 'Etternavn',
        placeholder: 'Etternavn',
      },
      bankAccount: {
        label: 'Bankkonto',
        placeholder: 'Bankkonto',
      },
      smallScaleManufacturer: {
        label: 'Årlig produksjon over 500.000 liter',
        placeholder: 'Aktiver',
      },
      businessRegistrationNumber: {
        label: 'Organisasjonsnummer',
        placeholder: 'Registreringsnummer',
      },
      isInternational: {
        label: 'Utenlandsbetaling',
        placeholder: 'Aktiver',
      },
      bankName: {
        label: 'Bank navn',
        placeholder: 'Bank navn',
      },
      swift: {
        label: 'Swift',
        placeholder: 'Swift',
      },
      iban: {
        label: 'IBAN',
        placeholder: 'IBAN',
      },
      isVatRegistered: {
        label: 'Registrert i Merverdiavgiftsregisteret',
        placeholder: 'Aktiver',
      },
      isRegisteredBusinessEnterprise: {
        label: 'Registrert i Foretaksregisteret',
        placeholder: 'Aktiver',
      },
      organizationTypeId: {
        label: 'Velg organisasjonstype',
        placeholder: 'Organisasjonstype',
      },
      organizationName: {
        label: 'Selskapsnavn',
        placeholder: 'Selskapsnavn',
      },
      organizationDescription: {
        label: 'Selskaps beskrivelse',
        placeholder: 'Selskaps beskrivelse',
      },
      organizationProfilePicture: {
        label: 'Organisasjons profilbilde',
        placeholder: 'Organisasjons profilbilde',
      },
      phoneNumber: {
        label: 'Telefonnummer',
        placeholder: 'Telefonnummer',
      },
      mobileNumber: {
        label: 'Mobilnummer',
        placeholder: 'Mobilnummer',
      },
      streetName: {
        label: 'Adresse',
        placeholder: 'Adresse',
      },
      gs1number: {
        label: 'GS1 leverandørnummer',
        placeholder: 'GS1 leverandørnummer',
      },
    },

    passwordForm: {
      currentPassword: {
        label: 'Nåværende passord',
        placeholder: 'Nåværende passord',
      },
      password: {
        label: 'Passord',
        placeholder: 'Passord',
      },
      passwordConfirmation: {
        label: 'Gjenta passord',
        placeholder: 'Gjenta passord',
      },
    },

    contactForm: {
      email: {
        label: 'Epost',
        placeholder: 'Epost',
      },
      firstName: {
        label: 'Fornavn',
        placeholder: 'Fornavn',
      },
      lastName: {
        label: 'Etternavn',
        placeholder: 'Etternavn',
      },
      phoneNumber: {
        label: 'Telefonnummer',
        placeholder: 'Telefonnummer',
      },
      mobileNumber: {
        label: 'Mobilnummer',
        placeholder: 'Mobilnummer',
      },
      streetName: {
        label: 'Adresse',
        placeholder: 'Adresse',
      },
      secondStreetName: {
        label: 'Adresse 2',
        placeholder: 'Adresse 2',
      },
      postalCode: {
        label: 'Postkode',
        placeholder: 'Postkode',
      },
      countryId: {
        label: 'Land',
        placeholder: 'Land',
      },
      cityName: {
        label: 'By',
        placeholder: 'By',
      },
      careOf: {
        label: 'C/O',
        placeholder: 'C/O',
      },
    },

    userSettingForm: {
      language: {
        label: 'Språk',
        placeholder: 'Velg Språk',
      },
    },

    profileAddress: {
      streetName: {
        label: 'Adresse',
        placeholder: 'Adresse',
      },
      secondStreetName: {
        label: 'Adresse 2',
        placeholder: 'Adresse 2',
      },
      postalCode: {
        label: 'Postnummer',
        placeholder: 'Postnummer',
      },
      countryId: {
        label: 'Velg land',
        placeholder: 'Velg land',
      },
      cityName: {
        label: 'Velg by',
        placeholder: 'Velg by',
      },
    },

    profileContact: {
      email: {
        label: 'Epost',
        placeholder: 'Epost',
      },
      firstName: {
        label: 'Fornavn',
        placeholder: 'Fornavn',
      },
      lastName: {
        label: 'Etternavn',
        placeholder: 'Etternavn',
      },
      phoneNumber: {
        label: 'Telefonnummer',
        placeholder: 'Telefonnummer',
      },
      mobileNumber: {
        label: 'Mobilnummer',
        placeholder: 'Mobilnummer',
      },
    },

    organizationSettings: {
      penaltyTypeForDueInvoice: {
        label: 'Reminder Type for Due Invoice',
        placeholder: 'Reminder Type for Due Invoice',
      },
      penaltyFee: {
        label: 'Penalty fee',
        placeholder: 'Penalty fee',
      },
      interestPercentage: {
        label: 'Interest percentage',
        placeholder: 'Interest percentage',
      },
      penaltyAfter: {
        label: 'After dueDate start penalty in (days)',
        placeholder: 'No. of days',
      },
      tosAccepted: {
        label: 'Akseptering av regler',
        placeholder:
          'Som bruker av Kundan, har vi lest og akseptert følgende regler og bruksvilkår: http://www.kundan.no/regler/',
      },
      marketingAllowed: {
        label: 'Ønsker info pr. epost',
        placeholder:
          'Vi takker ja til å motta nyheter, tilbud og annen relevant info via epost fra Kundan AS.',
      },
      customTos: {
        label: 'Egne bruksvilkår',
        placeholder:
          'Her kan du spesifisere bruksvilkår for dine egne produkter og tjenester.',
      },
      customOrderProductNote: {
        label: 'Ordrelinje notat',
        placeholder:
          'Her kan du ved bruk av variabler spesifisere om du ønsker ordrelinje notater opprettet automatisk basert på lagrede produkt data.',
      },
      facebookPixelId: {
        label: 'Facebook Piksel ID',
        placeholder: 'Facebook Piksel ID',
      },
      defaultClientGroupId: {
        label: 'Standard kundegruppe',
        placeholder: 'Velg kundegruppe som skal være standard',
      },
      defaultDueDays: {
        label: 'Standard forfallsdager',
        placeholder: 'Standard forfallsdager',
      },
      billingNumberDefault: {
        label: 'Nummerserie faktura',
        placeholder: 'Nummerserie faktura',
      },
      orderNumberDefault: {
        label: 'Nummerserie ordre',
        placeholder: 'Nummerserie ordre',
      },
      productNumberDefault: {
        label: 'Nummerserie produkt',
        placeholder: 'Nummerserie produkt',
      },
      productNumberInitial: {
        label: 'Selskapforkortelse',
        placeholder: 'Selskapforkortelse (3 bokstaver)',
      },
      defaultProductTypeName: {
        label: 'Standard produkttype',
        placeholder: 'Standard produkttype',
      },
      customerNumberDefault: {
        label: 'Nummerserie kunde',
        placeholder: 'Nummerserie kunde',
      },
      supplierNumberDefault: {
        label: 'Nummerserie leverandør',
        placeholder: 'Nummerserie leverandør',
      },
      timeslotGap: {
        label: 'Bestilling tilgjengelig hvert (minutt)',
        placeholder: 'Antall minutt',
      },
      invoiceNotes: {
        label: 'Faktura notat',
        placeholder: 'Notat som vises i faktura.',
      },
      billNotes: {
        label: 'Regningsnotater',
        placeholder: 'Notater som skal vises i regningen PDF.',
      },
      creditNoteNotes: {
        label: 'Kreditnota notat ',
        placeholder: 'Notat som vises i kreditnota.',
      },
      remindersEnabled: {
        label: 'Aktiver 24 timers påminnelse',
        placeholder: 'Aktiver påminnelse',
      },
      messageTemplateTypeId: {
        label: 'Meldingstype',
        placeholder: 'Velg en type',
      },
      smsFrom: {
        label: 'SMS avsender',
        placeholder: 'SMS avsender',
      },
      roundInvoiceTotal: {
        label: 'Automatisk øreavrunding',
        placeholder: 'Aktiver øreavrunding (kan overstyres fra hver faktura)',
      },
      invoiceEmailTitle: {
        label: 'Faktura epost emne',
        placeholder: 'Faktura epost emne',
        tooltip:
          'Tilgjengelige variabler: <br/><br/>Kundens fulle navn: {customer_name} <br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Fakturanummer: {bill_number}',
      },
      invoiceEmailTemplate: {
        label: 'Faktura epost innhold',
        placeholder: 'Faktura epost innhold',
        tooltip:
          'Tilgjengelige variabler: <br/><br/>Kundens fulle navn: {customer_name} <br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Fakturanummer: {bill_number}',
      },
      creditNoteEmailTitle: {
        label: 'Kreditnota epost emne',
        placeholder: 'Kreditnota epost emne',
      },
      creditNoteEmailTemplate: {
        label: 'Kreditnota epost innhold',
        placeholder: 'Kreditnota epost innhold',
      },
      reminderEmailTitle: {
        label: 'Betalingspåminnelse - epost emne',
        placeholder: 'Betalingspåminnelse - epost emne',
        tooltip:
        'Tilgjengelige variabler:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Regningsnummer: {bill_number}<br/>Fakturalink: {link}<br/>Organisasjonsnavn: {organization_name}<br/>Organisasjonskontaktnavn: {organization_contact_name}<br/>Tidsfrist: {due_date}',
      },
      reminderEmailTemplate: {
        label: 'Betalingspåminnelse - epost innhold',
        placeholder: 'Betalingspåminnelse - epost innhold',
        tooltip:
        'Tilgjengelige variabler:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Regningsnummer: {bill_number}<br/>Fakturalink: {link}<br/>Organisasjonsnavn: {organization_name}<br/>Organisasjonskontaktnavn: {organization_contact_name}<br/>Tidsfrist: {due_date}',
      },
      orderConfirmNotificationEmailTitle: {
        label: 'Tittel på mal for bestillingsbekreftelse på e-post',
        placeholder: 'Tittel på mal for bestillingsbekreftelse på e-post',
        tooltip:
        'Variabler tilgjengelig:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Ordrenummer: {order_number}<br/>Rekkefølge: {order}<br/>Organisasjonsnavn: {organization_name}',
      },
      orderConfirmNotificationEmailTemplate: {
        label: 'E-postmal for bestillingsbekreftelse',
        placeholder: 'E-postmal for bestillingsbekreftelse',
        tooltip:
        'Variabler tilgjengelig:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Ordrenummer: {order_number}<br/>Rekkefølge: {order}<br/>Organisasjonsnavn: {organization_name}',
      },
      orderTrackingEmailTitle: {
        label: 'tittel for e-postmal for ordresporing',
        placeholder: 'Tittel for e-postmal for ordresporing',
        tooltip:
        'Variabler tilgjengelig:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Ordrenummer: {order_number}<br/>Rekkefølge: {order}<br/>Ordresporingsnummer: {order_tracking_number}<br/>Bestillingssporingslenke: {tracking}<br/>Organisasjonsnavn: {organization_name}',
      },
      orderTrackingEmailTemplate: {
        label: 'E-postmal for ordresporing',
        placeholder: 'E-postmal for bestillingssporing',
        tooltip:
        'Variabler tilgjengelig:<br/><br/>Navn på bedrift/individ: {customer_name} <br/>Ordrenummer: {order_number}<br/>Rekkefølge: {order}<br/>Ordresporingsnummer: {order_tracking_number}<br/>Bestillingssporingslenke: {tracking}<br/>Organisasjonsnavn: {organization_name}',
      },
      accountingProviderId: {
        label: 'Regnskapssystem',
        placeholder: 'Velg regnskapsleverandør',
      },
      coa1460: {
        label: 'Innkjøpte varer for videresalg',
        placeholder: '',
      },
      coa1500: {
        label: 'Kundefordringer',
        placeholder: '',
      },
      coa1610: {
        label: 'Inngående merverdiavgift',
        placeholder: '',
      },
      coa1910: {
        label: 'Kasse',
        placeholder: '',
      },
      coa1920: {
        label: 'Bankinnskudd',
        placeholder: '',
      },
      coa2400: {
        label: 'Leverandørgjeld',
        placeholder: '',
      },
      coa2700: {
        label: 'Utgående merverdiavgift',
        placeholder: '',
      },
      coa3010: {
        label: 'Salgsinntekt egentilv. varer avgiftspl. høy sats',
        placeholder: '',
      },
      coa3020: {
        label: 'Salgsinntekt tjenester avgiftspl. høy sats',
        placeholder: '',
      },
      coa3060: {
        label: 'Uttak av varer avgiftspliktig høy sats',
        placeholder: '',
      },
      coa3080: {
        label: 'Rabatter og annen salgsinntektsred., avgiftspl.',
        placeholder: '',
      },
      ediBillingProcess: {
        label: 'EDI faktureringsmetode ved varemottak',
        placeholder: 'EDI faktureringsmetode',
      },
      paymentIdentitificationGeneration: {
        label: 'Aktiver KID generering',
        placeholder: '',
      },
      paymentIdentitificationTemplate: {
        label: 'KID mal',
        placeholder: '',
      },
      paymentIdentitificationNumberLength: {
        label: 'KID lengde (kontrollsiffer kommer i tillegg)',
        placeholder: '',
      },
      paymentIdentitificationModulusType: {
        label: 'Modulus type',
        placeholder: '',
      },
      defaultShippingProvider: {
        label: 'Standard fraktleverandør',
        placeholder: '',
      },
      defaultWarehouse: {
        label: 'Standard varelager',
        placeholder: '',
      },
      priceFields: {
        label: 'Aktive prisfelter',
        placeholder: '',
      },
      visiblePriceFields: {
        label: 'Synlige prisfelt',
        placeholder: '',
      },
      defaultPriceField: {
        label: 'Standard prisfelt',
        placeholder: '',
      },
      email_invoice_copy: {
        label: 'Email',
        placeholder: 'Email',
      },
      percentage: {
        label: 'Prosentdel (%)',
        placeholder: 'Prosentdel (%)',
      },
      enableRounding: {
        label: 'Aktiver avrunding',
        placeholder: 'Aktiver avrunding',
      },
      roundingType: {
        label: 'Avrundingstype',
        placeholder: 'Avrundingstype',
        options: {
          nearest_1: 'Nærmeste 1',
          nearest_0_50: 'Nærmeste 0,50',
          nearest_0_25: 'Nærmeste 0,25',
          nearest_0_99: 'Nærmeste 0,99',
          round_half_up: 'Rund Av Opp Halvveis',
          round_half_down: 'Rund Av Ned Halvveis',
          round_half_even: 'Rund Av Halvveis Til Nærmeste Partall (Bankrunding)',
          round_towards_zero: 'Rund Mot Null',
          round_away_from_zero: 'Rund Bort Fra Null',
        },
      },
      priceType: {
        label: 'Pristype',
        placeholder: 'Pristype',
      },
    },

    emailFormSettings: {
      emails: {
        label: 'Emails',
        placeholder: 'Emails',
      },
    },

    checkout: {
      bookingRequireAddress: {
        label: 'Adresse påkrevd',
        placeholder: 'Ja',
      },
      bookingRequirePayment: {
        label: 'Betaling påkrevd',
        placeholder: 'Ja',
      },
    },

    publicProfile: {
      profileUrl: {
        label: 'Profil nettside',
        placeholder: 'Profil nettside',
      },
      header: {
        label: 'Nettside overskrift',
        placeholder: 'Overskrift',
      },
      subheader: {
        label: 'Nettside undertekst',
        placeholder: 'Undertekst',
      },
      defaultReminderTitle: {
        label: 'Påminnelses emne',
        placeholder: 'Påminnelses emne',
        tooltip:
          'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}',
      },
      defaultReminder: {
        label: 'Påminnelses beskjed',
        placeholder: 'Påminnelses beskjed',
        tooltip:
          'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}',
      },
      defaultCancelMessageTitle: {
        label: 'Kansellerings emne',
        placeholder: 'Kansellerings emne',
        tooltip:
          'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}',
      },
      defaultCancelMessage: {
        label: 'Kansellerings beskjed',
        placeholder: 'Kansellerings beskjed',
        tooltip:
          'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}',
      },
      appointmentConfirmationTitle: {
        label: 'Bekreftelses emne',
        placeholder: 'Bekreftelses emne',
        tooltip:
          'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}',
      },
      appointmentConfirmationTemplate: {
        label: 'Bekreftelses beskjed',
        placeholder: 'Bekreftelses beskjed',
        tooltip:
          'Tilgjengelige variabler: <br/><br/>Kundens fornavn: {customer_firstname}<br/>Kundens etternavn: {customer_lastname}<br/>Bestilt produkt: {product}<br/>Dato: {date}<br/>Tid: {time}',
      },
      backgroundImage: {
        label: 'Bakgrunnsbilde',
        placeholder: 'Bakgrunnsbilde',
        changeImage: 'Endre bilde',
      },
    },

    clientGroups: {
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      description: {
        label: 'Beskrivelse',
        placeholder: 'Beskrivelse',
      },
      priceFieldId: {
        label: 'Prisfelt',
        placeholder: 'Prisfelt',
      },
      receivables_account_id: {
        label: 'Fordringskonto',
        placeholder: 'Fordringskonto',
        help: 'Brukes ved regnskapseksport når en kunde i gruppen ikke har egen fordringskonto.',
      },
    },

    clients: {
      basicInformation: 'Grunnleggende Informasjon',
      otherInformation: 'Annen informasjon',
      contacts: 'Kontakt',
      addresses: 'Adresser',
      licenses: 'Lisenser',
      postalAddressError: 'Informasjon om postadresse er obligatorisk.',
      primaryContactError: 'Primær kontaktinformasjon er obligatorisk.',
      addContact: 'Legg til kontakt',
      noContactWarning: 'Ingen kontakter ennå.',
      isSubClient: {
        label: 'Er underenhet',
        placeholder: 'Aktiv',
      },
      projectId: {
        label: 'Prosjekt',
        placeholder: '',
      },
      billMainParent: {
        label: 'Hovedenhet faktureres',
        placeholder: '',
      },
      dueDays: {
        label: 'Forfallsdager',
        placeholder: 'Forfallsdager',
      },
      clientTypes: {
        label: 'Type',
        placeholder: 'Type',
      },
      startBilling: {
        label: 'Start fakturering',
        placeholder: 'Start fakturering',
      },
      billingInterval: {
        label: 'Faktureringsintervall',
        placeholder: 'Faktureringsintervall',
      },
      automaticBilling: {
        label: 'Automatisk fakturering',
        placeholder: 'Automatisk fakturering',
      },
      billingType: {
        label: 'Faktureringstype',
        placeholder: 'Faktureringstype',
      },
      externalCustomerNumber: {
        label: 'Eksternt kunde #',
        placeholder: '',
      },
      orderReference: {
        label: 'Ordrereferanse',
        placeholder: '',
      },
      orderNote: {
        label: 'Ordrenotat',
        placeholder: '',
      },
      priceFieldId: {
        label: 'Prisfelt',
        placeholder: 'Velg prisfelt',
      },
      receivables_account_id: {
        label: 'Regnskapskonto',
        placeholder: 'Velg regnskapskonto',
        help: 'Hvis tom brukes kundegruppens fordringskonto (hvis satt) før organisasjonens standard.',
      },
      pricePercentageDiscount: {
        label: 'Kunde rabatt (%)',
        placeholder: 'Kunde rabatt (%)',
      },
      languageId: {
        label: 'Språk',
        placeholder: 'Velg språk',
      },
      currencyId: {
        label: 'Valuta',
        placeholder: 'Valuta',
      },
      typeId: {
        label: 'Type',
        placeholder: 'Type',
      },
      clientGroupId: {
        label: 'Velg kundegruppe',
        placeholder: 'Velg kundegruppe',
      },
      fullName: {
        label: 'Fullt navn',
        placeholder: 'Fornavn',
      },
      firstName: {
        label: 'Fornavn',
        placeholder: 'Fornavn',
      },
      lastName: {
        label: 'Etternavn',
        placeholder: 'Etternavn',
      },
      clientParent: {
        label: 'Hovedenhet',
        placeholder: 'Hovedenhet',
      },
      companyName: {
        label: 'Selskapsnavn',
        placeholder: 'Selskapsnavn',
      },
      clientType: {
        label: 'Kundetype',
        placeholder: 'Kundetype',
      },
      contactType: {
        label: 'Kontakttype',
        placeholder: 'Kontakttype',
      },
      email: {
        label: 'Epost',
        placeholder: 'Epost',
      },
      invoiceSendMethod: {
        label: 'Fakturametode',
        placeholder: 'Velg ønsket fakturametode',
      },
      phoneNumber: {
        label: 'Telefonnummer',
        placeholder: 'Telefonnummer',
      },
      mobileNumber: {
        label: 'Mobilnummer',
        placeholder: 'Mobilnummer',
        tooltip: 'Mobilnummeret  må være i formatet 4xx xx xxx or 9xx xx xxx.',
      },
      careOf: {
        label: 'C/O:',
        placeholder: 'C/O',
      },
      streetName: {
        label: 'Adresse',
        placeholder: 'Adresse',
      },
      secondStreetName: {
        label: 'Adresse 2',
        placeholder: 'Adresse 2',
      },
      postalCode: {
        label: 'Postnummer',
        placeholder: 'Postnummer',
      },
      countryId: {
        label: 'Velg land',
        placeholder: 'Velg land',
      },
      cityId: {
        label: 'By',
        placeholder: 'By',
      },
      cityName: {
        label: 'By',
        placeholder: 'By',
      },
      picture: {
        label: 'Velg bilde',
        placeholder: 'Velg bilde',
        placeholder2: 'Klikk for å laste opp',
        changeImage: 'Endre bilde',
      },
      organizationNumber: {
        label: 'Organisasjonsnummer',
        placeholder: 'Skriv inn org. nummer',
      },
      licenceTypeId: {
        label: 'Type kunde',
        placeholder: 'Velg type',
      },
      isProducer: {
        label: 'Er produsent',
        placeholder: 'Aktiv',
      },
      isSupplier: {
        placeholder: 'Er leverandør',
        label: 'Aktiv',
      },
      isActive: {
        label: 'Aktiv kunde',
        placeholder: 'Aktiv',
      },
      manualProcessOrder: {
        label: 'Manuell order godkjenning',
        placeholder: 'Aktiv',
      },
      gln: {
        label: 'GLN number',
        placeholder: 'GLN number',
      },
      glnXKoord: {
        label: 'GLN x-coordinates',
        placeholder: 'GLN x-coordinates',
      },
      glnYKoord: {
        label: 'GLN y-coordinates',
        placeholder: 'GLN y-coordinates',
      },
      syncToWoo: {
        label: 'Synkroniser til Nettbutikk',
        placeholder: '',
      },
    },

    catalogues: {
      actionCode: {
        label: 'Type',
        placeholder: 'Type',
      },
      productGroupId: {
        label: 'Produktgruppe',
        placeholder: 'Produktgruppe',
      },
      name: {
        label: 'Katalog navn',
        placeholder: 'Katalog navn',
      },
      issuedAt: {
        label: 'Dato utstedet',
        placeholder: 'Dato utstedet',
      },
      versionId: {
        label: 'Versjon',
        placeholder: 'Versjon',
      },
      validFrom: {
        label: 'Gyldig fra',
        placeholder: 'Gyldig fra',
      },
      validTo: {
        label: 'Gyldig til',
        placeholder: 'Gyldig til',
      },
      reference: {
        label: 'Referanse',
        placeholder: 'Referanse',
      },
      note: {
        label: 'Intern notat',
        placeholder: 'Intern notat',
      },
    },

    producers: {
      typeId: {
        label: 'Type',
        placeholder: 'Type',
      },
      name: {
        label: 'Firmanavn',
        placeholder: 'Skriv inn firmanavn',
      },
    },

    billingTypes: {
      options: {
        single: 'Enkeltvis',
        consolidate: 'Samlet',
      },
    },

    automaticBilling: {
      options: {
        none: 'Ingen',
        weekly: 'Ukentlig',
        monthly: 'Månedlig',
      },
    },

    billingInterval: {
      week: {
        options: {
          week1: '1 uke',
          week2: '2 uker',
          week3: '3 uker',
        },
      },
      month: {
        options: {
          month1: '1 måned',
          month2: '2 måneder',
          month3: '3 måneder',
          month4: '4 måneder',
          month5: '5 måneder',
          month6: '6 måneder',
        },
      },
    },

    startBilling: {
      week: {
        options: {
          monday: 'Mandag',
          tuesday: 'Tirsdag',
          wednesday: 'Onsdag',
          thursday: 'Torsdag',
          friday: 'Fredag',
          saturday: 'Lørdag',
          sunday: 'Søndag',
        },
      },
      month: {
        options: {
          day: 'Dag',
        },
      },
    },

    addressTypes: {
      updateActions: 'Oppdater handlinger',
      options: {
        postal: 'Postadresse',
        physicalAddress: 'Besøksadresse',
        deliveryAddress: 'Leveringsadresse',
      },
    },

    contactTypes: {
      options: {
        primary: 'Hoved',
        accounting: 'Regnskap',
      },
    },

    productGroups: {
      parentGroupId: {
        label: 'Foreldre gruppe',
        placeholder: 'Velg overordnet gruppe',
      },
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      description: {
        label: 'Beskrivelse',
        placeholder: 'Beskrivelse',
      },
    },

    productBundles: {
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      description: {
        label: 'Beskrivelse',
        placeholder: 'Beskrivelse',
      },
      price: {
        label: 'Pakkepris (eks MVA)',
        placeholder: 'Pris',
      },
      groupName: {
        label: 'Gruppenavn',
        placeholder: 'Gruppenavn',
      },
      groupPrice: {
        label: 'Gruppepris',
        placeholder: '',
      },
      groupTax: {
        label: 'MVA %',
        placeholder: '',
      },
    },

    productPackagings: {
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      volume: {
        label: 'Volum (ℓ)',
        placeholder: 'Volum (ℓ)',
      },
      qtyInCrate: {
        label: 'Antall enheter i kasse',
        placeholder: 'Antall enheter i kasse',
      },
      packagingTypeId: {
        label:
          'Forpakningstype (Brukes i forbindelse med bl.a rapportering til BROD)',
        placeholder: 'Forpakningstype',
      },
      packagingMaterialId: {
        label:
          'Forpakningsmateriale (Brukes i forbindelse med beregning av avgift til Skatteetaten)',
        placeholder: 'Forpakningsmateriale',
      },
      materialId: {
        label: 'Råvare pr. forpakning brukt under tapping',
        placeholder: 'Råvare forpaknings materiale',
      },
      crateMaterialId: {
        label: 'Råvare pr. kasse brukt under tapping',
        placeholder: 'Råvare kasse materiale',
      },
      overrideProductsConfirm: {
        title: 'Overstyr relaterte produkter',
        description:
          'Dette vil oppdatere alle avgifter og innskudd av produkter som tilhører denne pakken.',
      },
    },
    products: {
      number: {
        label: 'Produktnummer',
        placeholder: 'Produktnummer',
      },
      name: {
        label: 'Produktnavn',
        placeholder: 'Produktnavn',
      },
      description: {
        label: 'Beskrivelse',
        placeholder: 'Beskrivelse',
      },
      subType: {
        label: 'Subtype',
        placeholder: 'Velg subtype',
      },
      recommendations: {
        label: 'Passer til',
        placeholder: 'Passer til',
      },
      note: {
        label: 'Notat',
        placeholder: 'Notat',
      },
      isActive: {
        label: 'Aktivt produkt',
        placeholder: 'Aktiver',
      },
      containsAlcohol: {
        label: 'Inneholder alkohol',
        placeholder: 'Aktiver',
      },
      externalId: {
        label: 'Eksternt produktnr',
        placeholder: '',
      },
      productGroupId: {
        label: 'Produktgruppe',
        placeholder: 'Velg produktgruppe',
      },
      alcoholPercentage: {
        label: 'Alkohol %',
        placeholder: 'ABV',
      },
      productPackagingId: {
        label: 'Produkt forpakning',
        placeholder: 'Velg forpakning',
      },
      productTagId: {
        label: 'Stikkord',
        placeholder: 'Velg stikkord',
      },
      productTypeId: {
        label: 'Produkttype',
        placeholder: 'Velg produkttype',
      },
      productSubtype: {
        label: 'Subtype',
        placeholder: 'Velg subtype',
      },
      productSubtypeId: {
        label: 'Subtype',
        placeholder: 'Velg subtype',
      },
      productType: {
        label: 'Produkttype',
        placeholder: 'Velg produkttype',
      },
      taxId: {
        label: 'Velg MVA prosent',
        placeholder: 'MVA',
      },
      price: {
        label: 'Salgspris',
        placeholder: 'Salgspris',
      },
      retailPrice: {
        label: 'Utsalgspris',
        placeholder: 'Utsalgspris',
      },
      duration: {
        label: 'Varighet',
        placeholder: 'Varighet',
      },
      breaktime: {
        label: 'Pause',
        placeholder: 'Pause',
      },
      appointable: {
        label: 'Tilgjengelig for online booking?',
        placeholder: 'Aktiver',
      },
      icon: {
        label: 'Velg ikon',
        placeholder: 'Ikon',
        changeImage: 'Endre bilde',
        removeImage: 'Slett bilde',
      },
      image: {
        label: 'Velg et bilde',
        placeholder: 'Bilde',
        changeImage: 'Endre bilde',
      },
      depositCheck: {
        label: 'Pant på produkt',
        placeholder: 'Aktiver pant',
      },
      deposit: {
        label: 'Pant',
        placeholder: 'Aktiver',
      },
      productDepositCheckbox: {
        label: 'Pant på produkt',
        placeholder: 'Aktiver pant',
      },
      productDepositId: {
        label: 'Pantesats',
        placeholder: 'Velg pant',
      },
      overrideProducts: {
        label: 'Overstyr produkter',
        placeholder: '',
      },
      purchasePrice: {
        label: 'Innkjøpspris',
        placeholder: '',
      },
      costPrice: {
        label: 'Kostpris',
        placeholder: '',
      },
      paidExcise: {
        label: 'Forhåndsbetalt avgift?',
        placeholder: '',
      },
      excisable: {
        label: 'Særavgiftspliktig?',
        placeholder: 'Aktiver særavgiftsberegning',
      },
      containSugar: {
        label: 'Inneholder sukker?',
        placeholder: 'Aktiver sukkerinnhold',
      },
      lowCalorie: {
        label: 'Lav-kalori?',
        placeholder: 'Marker hvis produktet er lav-kalori (BROD-rapport)',
      },
      exciseGroupId: {
        label: 'Avgiftsgruppe',
        placeholder: 'Avgiftsgruppe',
      },
      exciseAlcoholGroup: {
        label: 'Alkoholavgift',
        placeholder: 'Alkoholavgift',
      },
      excisePackagingGroup: {
        label: 'Miljøavgift',
        placeholder: 'Miljøavgift',
      },
      exciseBasicGroup: {
        label: 'Basisavgift',
        placeholder: 'Basisavgift',
      },
      chartOfAccounts: {
        label: 'Regnskapskonto',
        placeholder: 'Regnskapskonto',
      },
      producer: {
        label: 'Produsentnavn',
        placeholder: 'Navn på produsent',
      },
      region: {
        label: 'Distrikt',
        placeholder: '',
      },
      subRegion: {
        label: 'Underdistrikt',
        placeholder: '',
      },
      country: {
        label: 'Land',
        placeholder: '',
      },
      vintage: {
        label: 'Årgang',
        placeholder: '',
      },
      alcohol_percentage: {
        label: 'Alkohol (%)',
        placeholder: '',
      },
      bottle_volume: {
        label: 'Flaskevolum (ℓ)',
        placeholder: '',
      },
      sugar: {
        label: 'Sukker (g)',
        placeholder: '',
      },
      acid: {
        label: 'Syre',
        placeholder: '',
      },
      fullness: {
        label: 'Fylde',
        placeholder: '',
      },
      freshness: {
        label: 'Friskhet',
        placeholder: '',
      },
      bitterness: {
        label: 'Bitterhet',
        placeholder: '',
      },
      sweetness: {
        label: 'Sødme',
        placeholder: '',
      },
      tannins: {
        label: 'Garvestoffer',
        placeholder: '',
      },
      colour: {
        label: 'Farge',
        placeholder: '',
      },
      odour: {
        label: 'Lukt',
        placeholder: '',
      },
      taste: {
        label: 'Smak',
        placeholder: '',
      },
      storagePotential: {
        label: 'Lagringsgrad',
        placeholder: '',
      },
      ingredients: {
        label: 'Ingredienser',
        placeholder: '',
      },
      organic: {
        label: 'Økologisk',
        placeholder: '',
      },
      biodynamic: {
        label: 'Biodynamisk',
        placeholder: '',
      },
      locallyProduced: {
        label: 'Lokalprodusert',
        placeholder: '',
      },
      environmentallySmart: {
        label: 'Fairtrade',
        placeholder: '',
      },
      freeOrLowOnGluten: {
        label: 'Lav på gluten',
        placeholder: '',
      },
      kosher: {
        label: 'Kosher',
        placeholder: '',
      },
      cork_type: {
        label: 'Korktype',
        placeholder: '',
      },
      packaging_type: {
        label: 'Emballasjetype',
        placeholder: '',
      },
      gtin: {
        label: 'GTIN #',
        placeholder: 'GTIN nummer',
      },
      gtinMultipack: {
        label: 'GTIN # flerforpakning',
        placeholder: 'GTIN nummer flerforpakning',
      },
      sa: {
        label: 'SA # ',
        placeholder: 'Suppliers Article nummer',
      },
      nobb: {
        label: 'NOBB #',
        placeholder: 'Norsk Byggevarebase nummer',
      },
      sourceProductId: {
        label: 'Produkt å slette',
        placeholder: 'Produkt å slette',
      },
      destinationProductId: {
        label: 'Slå sammen med',
        placeholder: 'Slå sammen med',
      },
      is_taxable: {
        label: 'MVA pliktig',
        placeholder: 'MVA pliktig',
      },
      inventoryExclude: {
        label: 'Ignorer varelager',
        placeholder: 'Aktiver',
      },
      retailPriceVmp: {
        label: 'Utsalgspris VMP',
        placeholder: '',
      },
      ddpVmp: {
        label: 'DDP VMP',
        placeholder: '',
      },
      salePriceHoreca: {
        label: 'Salgspris Horeca',
        placeholder: '',
      },
      salesPriceAsko: {
        label: 'Salgspris Asko',
        placeholder: '',
      },
      salesPriceVinhuset: {
        label: 'Salgspris Vinhuset',
        placeholder: '',
      },
      salesPriceWholesale: {
        label: 'Salgspris grossist',
        placeholder: '',
      },
      salesPriceGrocery: {
        label: 'Salgspris dagligvare',
        placeholder: '',
      },
      salesPriceBusiness: {
        label: 'Salgspris bedrift',
        placeholder: '',
      },
      salesPriceSpecialtyStore: {
        label: 'Salgspris spesialbutikk',
        placeholder: '',
      },
      salesPriceVinhusetAsko: {
        label: 'Salgspris Vinhuset Asko',
        placeholder: '',
      },
      coop: {
        label: 'Coop',
        placeholder: '',
      },
      rema1000: {
        label: 'Rema 1000',
        placeholder: '',
      },
      packaging: {
        label: 'Forpakning',
        placeholder: '',
      },
      weightUnit: {
        label: 'Vekt enhet (kg)',
        placeholder: '',
      },
      weightMultipack: {
        label: 'Vekt flerforpakning (kg)',
        placeholder: '',
      },
      measureUnit: {
        label: 'Mål enhet (cm)',
        placeholder: '',
      },
      measureMultiPackaging: {
        label: 'Mål flerforpakning (cm)',
        placeholder: '',
      },
      numberUnitsMultiPackaging: {
        label: 'Antall enheter i flerforpakning',
        placeholder: '',
      },
      numberUnitsPallet: {
        label: 'Antall enheter på pall',
        placeholder: '',
      },
      availableVinhuset: {
        label: 'Tilgjengelig hos Vinhuset',
        placeholder: 'Aktiver',
      },
      availableAsko: {
        label: 'Tilgjengelig hos Asko',
        placeholder: 'Aktiver',
      },
      epd: {
        label: 'EPD #',
        placeholder: 'EPD ID',
      },
      sku: {
        label: 'SKU #',
        placeholder: '',
      },
      vmp: {
        label: 'VMP #',
        placeholder: 'VMP produkt ID',
      },
      internalNote: {
        label: 'Notat',
        placeholder: '',
      },
      depositSystemId: {
        label: 'Innskuddssystem',
        placeholder: 'Innskuddssystem',
      },
      lastChanged: {
        label: 'Siste endret',
        placeholder: 'Sist endret',
      },
      marketplaceEnabled: {
        label: 'DrikkeRiket',
        placeholder: 'Aktivert',
      },
      shortDescription: {
        label: 'Kort beskrivelse',
        placeholder: 'Kort beskrivelse',
      },
      longDescription: {
        label: 'Detaljert beskrivelse',
        placeholder: 'Detaljert beskrivelse',
      },
      manualProcessOrder: {
        label: 'Manuell order godkjenning',
        placeholder: 'Aktiv',
      },
      unProductCodeId: {
        label: 'FNs produktkode',
        placeholder: 'Søk i FNs produktkode...',
      },
      updateSku: {
        label: 'Oppdatere SKU?',
        placeholder: '',
      },
      minimumOrderQuantity: {
        label: 'Minimum antall',
        placeholder: '',
      },
      orderableUnitId: {
        label: 'Bestillbar enhet',
        placeholder: '',
      },
      syncToWoo: {
        label: 'Synkroniser til Nettbutikk',
        placeholder: '',
      },
      onlineStorePrice: {
        label: 'Salgspris nettbutikk',
        placeholder: 'Salgspris eks. mva',
      },
      sellInCase: {
        label: 'Selg kassevis',
        placeholder: '',
      },
      minQty: {
        label: 'Minimumsmengde',
        placeholder: '',
      },
      groupOf: {
        label: 'Gruppe av',
        placeholder: '',
      },
      packagingMaterial: {
        label: 'Forpakningsmateriale',
        placeholder: '',
      },
      packagingMaterialId: {
        label: 'Forpakningsmateriale ID',
        placeholder: '',
      },
      packagingName: {
        label: 'Forpakningstype',
        placeholder: '',
      },
      packagingQuantity: {
        label: 'Antall i forpakning',
        placeholder: '',
      },
    },

    productTags: {
      tag: {
        label: 'Stikkord',
        placeholder: 'Stikkord',
      },
    },

    priceFields: {
      field: {
        label: 'Field',
        placeholder: 'Field',
      },
    },

    materials: {
      number: {
        label: 'Nummer',
        placeholder: 'Nummer',
      },
      materialTypeId: {
        label: 'Type',
        placeholder: 'Type',
      },
      unitMeasureId: {
        label: 'Måleenhet',
        placeholder: 'Måleenhet',
      },
      supplierId: {
        label: 'Leverandør/Produsent',
        placeholder: 'Leverandør/Produsent',
      },
      minimumStockLevel: {
        label: 'Lagerbehov',
        placeholder: 'Lagerbehov',
      },
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      description: {
        label: 'Beskrivelse',
        placeholder: 'Beskrivelse',
      },
    },

    batches: {
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      batchNumber: {
        label: 'Batch #',
        placeholder: 'Batch #',
      },
      priorityNumber: {
        label: 'Prioritering',
        placeholder: 'Prioritering',
      },
      recipeId: {
        label: 'Oppskrift',
        placeholder: 'Oppskrift',
      },
      plannedStartingDate: {
        label: 'Planlagt startdato',
        placeholder: 'Planlagt startdato',
      },
      startDate: {
        label: 'Startdato',
        placeholder: 'Startdato',
      },
      endDate: {
        label: 'Sluttdato',
        placeholder: 'Sluttdato',
      },
      bestBeforeDate: {
        label: 'Best før dato',
        placeholder: 'Best før dato',
      },
      expirationDate: {
        label: 'Utgått dato',
        placeholder: 'Utgått dato',
      },
      notes: {
        label: 'Notater',
        placeholder: 'Notater',
      },
      description: {
        label: 'Beskrivelse',
        placeholder: 'Beskrivelse',
      },
      timestamp: {
        label: 'Tid',
        placeholder: 'Tid',
      },
      statuses: {
        planned: 'Planlegg batch',
        started: 'Start ny batch',
        completed: 'Registrer fullført batch',
      },
    },

    recipes: {
      recipeTypeId: {
        label: 'Oppskriftstype',
        placeholder: 'Oppskriftstype',
      },
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      notes: {
        label: 'Notat',
        placeholder: 'Notat',
      },
    },

    campaigns: {
      name: {
        label: 'Kampanjenavn',
        placeholder: 'Navn på kampanjen',
      },
      description: {
        label: 'Forklaring',
        placeholder: 'Hva gjelder kampanjen?',
      },
      campaignTypeId: {
        label: 'Kampanjetype',
        placeholder: 'Kampanjetype',
      },
      newsSubscriberListId: {
        label: 'Liste',
        placeholder: 'Liste',
      },
    },

    subscriberList: {
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      selectDefaultEmail: {
        label: 'Bruk standard e-post',
        placeholder: '',
      },
      fromEmail: {
        label: 'Fra e-post',
        placeholder: 'Fra e-post',
      },
      selectDefaultName: {
        label: 'Bruk standardnavn',
        placeholder: '',
      },
      fromName: {
        label: 'Fra navn',
        placeholder: 'Fra navn',
      },
      description: {
        label: 'Beskrivelse',
        placeholder: 'Beskrivelse',
      },
      doubleOptinRequired: {
        label: 'Dobbeltoptin',
        placeholder: '',
      },
      mailSubject: {
        label: 'Emne',
        placeholder: 'Emne',
      },
      mailBody: {
        label: 'Kropp',
        placeholder: 'Kropp',
      },
    },

    news: {
      subject: {
        label: 'Emne',
        placeholder: 'Emne',
      },
      body: {
        label: 'Beskjed',
        placeholder: 'Beskjed',
      },
      sendAfterDate: {
        label: 'Sendedato',
        placeholder: 'Velg sendedato',
      },
      sendAfterTime: {
        label: 'Sendetid',
        placeholder: 'Velg sendetid',
      },
      sendAfter: {
        label: 'Send etter antall (x) timer',
        placeholder: 'Send etter timer',
      },
      testEmail: {
        label: 'Test email',
        placeholder: 'mail@mail.com',
      },
      testEmailCheck: {
        label: 'Use custom email',
        placeholder: '',
      },
      status: {
        label: 'Status',
      },
      htmlEmail: {
        label: 'Use Html Email',
        placeholder: '',
      },
    },

    orders: {
      createdAt: {
        label: 'Ordredato',
        placeholder: 'Ordredato',
      },
      orderTypeId: {
        label: 'Ordretype',
        placeholder: 'Ordretype',
      },
      projectId: {
        label: 'Prosjekt',
        placeholder: 'Prosjekt',
      },
      productId: {
        label: 'Velg produktet',
        placeholder: 'Produkt',
      },
      batchId: {
        label: 'Velg batch',
        placeholder: 'Velg batch',
      },
      available: {
        label: 'Lagerstatus',
        placeholder: 'Lagerstatus',
      },
      clientId: {
        label: 'Velg kunde',
        placeholder: 'Kunde',
      },
      referenceNumber: {
        label: 'Ordre referanse',
        placeholder: 'Ordre referanse',
      },
      internalNote: {
        label: 'Notat',
        placeholder: 'Notat',
      },
      date: {
        label: 'Dato',
        placeholder: 'Dato',
      },
      slot: {
        label: 'Velg tidspunkt',
        placeholder: 'Time Slots',
      },
      timeSlots: {
        label: 'Starttid',
      },
      time: {
        label: 'Tid',
        placeholder: 'Tid',
      },
      duration: {
        label: 'Varighet',
        placeholder: 'Varighet',
      },
      details: {
        label: 'Detaljer',
        placeholder: 'Detaljer',
      },
    },

    ediOrders: {
      deliveryDate: {
        label: 'Leveringsdato',
        placeholder: 'Leveringsdato',
      },
      orderNumber: {
        label: 'Vinmonopolets ordre nummer',
        placeholder: 'Velg opprinnelig ordre',
      },
    },

    bills: {
      languageId: {
        label: 'Velg språk',
        placeholder: 'Språk',
      },
      currencyId: {
        label: 'Velg valuta',
        placeholder: 'Valuta',
      },
      orderId: {
        label: 'Velg ordre',
        placeholder: 'Ordre',
      },
      billTypeId: {
        label: 'Velg fakturatype',
        placeholder: 'Type',
      },
      billStatusId: {
        label: 'Velg fakturastatus',
        placeholder: 'Status',
      },
      dueDate: {
        label: 'Forfallsdato',
        placeholder: 'Forfallsdato',
      },
      summaryGrouping: {
        label: 'Sammendrag gruppering',
        placeholder: '',
      },
      date: {
        label: 'Dato',
        placeholder: 'Dato',
      },
      paymentDate: {
        label: 'Betalingsdato',
        placeholder: 'Betalingsdato',
      },
      creditNoteValue: {
        label: 'Kreditnota verdi',
        placeholder: 'Verdi',
      },
      paymentMessage: {
        label: 'Betalingsreferanse',
        placeholder: 'Meldingstekst',
      },
      kidNumber: {
        label: 'KID',
        placeholder: 'KID',
      },
      note: {
        label: 'Notat',
        placeholder: 'Notat',
      },
    },

    addEditPackage: {
      packageUnitTypeId: {
        label: 'Enhetstype',
        placeholder: 'Enhetstype',
      },
      sscc: {
        label: 'SSCC',
        placeholder: 'Kollinummer (generes automatisk hvis blankt)',
      },
      parentId: {
        label: 'Foreldrepakke',
        placeholder: 'Foreldrepakke',
      },
      packingLevel: {
        label: 'Pakketype',
        placeholder: 'Pakketype',
      },
    },

    addEditProductToPackage: {
      productName: {
        label: 'Produkter',
        placeholder: 'Produkter',
      },
      orderProductId: {
        label: 'Produkter',
        placeholder: 'Produkter',
      },
      quantity: {
        label: 'Antall enheter',
        placeholder: 'Antall enheter',
      },
      quantityUnit: {
        label: 'Målenhet',
        placeholder: 'Målenhet',
      },
      grossWeight: {
        label: 'Bruttovekt',
        placeholder: 'Bruttovekt',
      },
      netWeight: {
        label: 'Nettovekt',
        placeholder: 'Nettovekt',
      },
      stackWeight: {
        label: 'Stablevekt',
        placeholder: 'Stablevekt',
      },
      bestBefore: {
        label: 'Best før',
        placeholder: 'Best før',
      },
      maxTopLoad: {
        label: 'Maks topplast',
        placeholder: 'Maks topplast',
      },
      batchLotNumber: {
        label: 'Batch / Lot nummer',
        placeholder: 'Batch / Lot nummer',
      },
      temperatureRequirement: {
        label: 'Temperatur (i °C)',
        placeholder: 'Temperatur (i °C)',
      },
    },

    exciseEntry: {
      product: {
        placeholder: 'Produkt velg',
        label: '',
      },
      source: {
        placeholder: 'Kilde velg',
        label: '',
      },
    },
  },

  table: {
    noData: 'Ingen data funnet',
    projects: {
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      description: {
        label: 'Beskrivelse',
        placeholder: 'Beskrivelse',
      },
    },
    clientReports: {
      id: 'ID',
      name: 'Navn',
      clientNumber: 'Kunde #',
      balance: 'Balanse',
      createdAt: 'Opprettet',
      lastSent: 'Sist sendt',
      email: 'Epost',
    },
    stock: {
      products: {
        productId: {
          label: 'Navn',
          placeholder: 'Navn',
        },
        batchId: {
          label: 'Batch',
          placeholder: 'Velg batch',
        },
        currentCount: {
          label: 'System beholdning',
          placeholder: 'System beholdning',
        },
        physicalCount: {
          label: 'Ny lagerbeholdning',
          placeholder: 'Ny lagerbeholdning',
        },
        variance: {
          label: 'Forskjell (+/-)',
          placeholder: 'Forskjell (+/-)',
        },
      },
    },
    adjustment: {
      products: {
        productId: {
          label: 'Produkt',
          placeholder: 'Velg produkt',
        },
        batchId: {
          label: 'Batch',
          placeholder: 'Velg batch',
        },
        qty: {
          label: 'Justering (+/-)',
          placeholder: 'Justering (+/-)',
          customDeduct: 'Trekk',
        },
        currentAdjustment: {
          label: 'Systembeholdning',
          placeholder: 'Systembeholdning',
        },
      },
    },
    warehouseReports: {
      productName: 'Produkt',
      productValue: 'Produktverdi',
      nameOfWarehouse: 'Varelager',
      productNumber: 'Produktnr.',
      vmpNumber: 'VMP nr.',
      qtyAvailable: 'Antall',
      crateQtyAvailable: 'Kasser',
    },
    products: {
      productId: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      qty: {
        label: 'Antall',
        placeholder: 'Antall',
      },
    },
    shippingProviders: {
      name: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      code: {
        label: 'Kode',
        placeholder: 'Kode',
      },
    },
    productBundles: {
      productId: {
        label: 'Produkt',
        placeholder: 'Produkt',
      },
      price: {
        label: 'Pris',
        placeholder: 'Pris',
      },
      qty: {
        label: 'Antall',
        placeholder: 'Antall',
      },
    },
    productsCustom: {
      productId: {
        label: 'Navn',
        placeholder: 'Navn',
      },
      qty: {
        label: 'Justering (+/-)',
        placeholder: 'Justering (+/-)',
      },
      currentAdjustment: {
        label: 'Systembeholdning',
        placeholder: 'Systembeholdning',
      },
      qtyReceive: {
        label: 'Antall mottatt',
        placeholder: 'Antall mottatt',
      },
      qtyDamage: {
        label: 'Skadet / manko',
        placeholder: 'Skadet / manko',
      },
      costPrice: {
        label: 'Kostpris',
        placeholder: 'Kostpris',
      },
      purchasePrice: {
        label: 'Innkjøpspris',
        placeholder: 'Innkjøpspris',
      },
      notes: {
        label: 'Notat',
        placeholder: 'Notat',
      },
      batchId: {
        label: 'Batch',
        placement: 'Batch',
      },
    },
    orderProducts: {
      addProductsButton: 'Legg til produkter',
      addAllBillProductsButton: 'Legg til alle fakturalinjer',
      addAllBillProductsNothing: 'Alle fakturalinjene er allerede på kreditnotaen.',
      addAllBillProductsSuccess: 'La til {count} linje(r) på kreditnotaen.',
      addAllBillProductsError: 'Kunne ikke legge til alle linjer. Prøv enkeltvis.',
      product: {
        label: 'Rediger produkt',
      },
      name: {
        label: 'Produkt',
        placeholder: 'Navn',
      },
      taxId: {
        label: 'MVA (%)',
        placeholder: 'Velg...',
      },
      batchId: {
        label: 'Batch',
        placeholder: 'Batch',
      },
      available: {
        label: 'Lagerantall',
        placeholder: 'Lagerantall',
      },
      price: {
        label: 'Pris',
        placeholder: 'Pris',
      },
      quantity: {
        label: 'Antall',
        placeholder: 'Antall',
      },
      discount: {
        label: 'Rabatt (%)',
      },
      quantityOrdered: {
        label: 'Antall bestilt',
      },
      quantityConfirmed: {
        label: 'Antall bekreftet',
      },
      quantityReceived: {
        label: 'Antall mottatt',
      },
      quantityUnconfirmed: {
        label: 'Unconfirmed',
      },
      returnCodeDescription: {
        label: 'Retur Årsak',
      },
      unitTypeId: {
        label: 'Enhet',
        placeholder: '',
      },
      unitQuantity: {
        label: 'Enhet Antall',
        placeholder: '',
      },
    },
    billProducts: {
      billProductId: {
        label: 'Produkt',
        placeholder: 'Velg produkt',
      },
      orderProductId: {
        label: 'Produkt',
        placeholder: 'Velg ordre produkt',
      },
      productDepositId: {
        label: 'Pant',
        placeholder: 'Velg pant',
      },
      taxId: {
        label: 'MVA (%)',
        placeholder: 'Velg...',
      },
      price: {
        label: 'Pris',
        placeholder: 'Pris',
      },
      quantity: {
        label: 'Antall',
        placeholder: 'Antall',
      },
      discount: {
        label: 'Rabatt (%)',
        placeholder: 'Rabatt (%)',
      },
      ref: {
        label: 'Ref #',
        placeholder: 'Ref #',
      },
    },
    businessHours: {
      addOpeningHours: 'Add Opening Hours',
      businessDays: {
        placeholder: 'Dager',
        label: 'Dager',
      },
      start: {
        placeholder: 'Start tid',
        label: 'Start tid',
      },
      end: {
        placeholder: 'Avslutt tid',
        label: 'Avslutt tid',
      },
    },
    businessHourExceptions: {
      addExceptionalHours: 'Add Exceptional Hours',
      date: {
        placeholder: 'Dato',
        label: 'Dato',
        placeholderStart: 'Fra dato',
        placeholderEnd: 'Til dato',
      },
      start: {
        placeholder: 'Start tid',
        label: 'Start tid',
      },
      end: {
        placeholder: 'Avslutt tid',
        label: 'Avslutt tid',
      },
      message: {
        placeholder: 'Melding',
        label: 'Melding',
      },
    },
    recipeIngrediences: {
      materialId: {
        label: 'Material',
        placeholder: 'Material',
      },
      amount: {
        label: 'Mengde',
        placeholder: 'Mengde',
      },
      unitMeasure: {
        label: 'Måleenhet',
        placeholder: 'Måleenhet',
      },
      deductedAmount: {
        label: 'Trukket',
        placeholder: 'Trukket',
      },
      noResult: 'Ingen ingredienser lagt til enda.',
    },
    ediOrderItems: {
      name: {
        label: 'Produkt',
        placeholder: 'Navn',
      },
      price: {
        label: 'Pris',
      },
      quantityOrdered: {
        label: 'Antall bestilt',
      },
      quantityConfirmed: {
        label: 'Antall bekreftet',
      },
      max: {
        label: 'Maks',
      },
    },
  },

  // ElementUI locale
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Fjern',
    },
    datepicker: {
      now: 'Nå',
      today: 'Idag',
      cancel: 'Avbryt',
      clear: 'Fjern',
      confirm: 'OK',
      selectDate: 'Velg dato',
      selectTime: 'Velg tid',
      startDate: 'Start dato',
      startTime: 'Start tid',
      endDate: 'Slutt dato',
      endTime: 'Slutt tid',
      prevMonth: 'Forrige måned',
      nextMonth: 'Neste måned',
      prevYear: 'Forrige år',
      nextYear: 'Neste år',
      year: '',
      month1: 'Jan',
      month2: 'Feb',
      month3: 'Mar',
      month4: 'Apr',
      month5: 'Mai',
      month6: 'Jun',
      month7: 'Jul',
      month8: 'Aug',
      month9: 'Sep',
      month10: 'Okt',
      month11: 'Nov',
      month12: 'Des',
      // week: 'Uke',
      weeks: {
        sun: 'Søn',
        mon: 'Man',
        tue: 'Tir',
        wed: 'Ons',
        thu: 'Tor',
        fri: 'Fre',
        sat: 'Lør',
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'Mai',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Okt',
        nov: 'Nov',
        dec: 'Des',
      },
    },
    select: {
      loading: 'Laster',
      noMatch: 'Ingen matchende data',
      noData: 'Ingen data',
      placeholder: 'Velg',
    },
    cascader: {
      noMatch: 'Ingen matchende data',
      placeholder: 'Velg',
    },
    pagination: {
      goto: 'Gå til',
      pagesize: '/side',
      total: 'Total {total}',
      pageClassifier: '',
    },
    messagebox: {
      title: 'Melding',
      confirm: 'OK',
      cancel: 'Avbryt',
      error: 'Ulovlig input',
    },
    upload: {
      delete: 'Slett',
      preview: 'Forhåndsvisning',
      continue: 'Fortsett',
    },
    table: {
      emptyText: 'Ingen data',
      confirmFilter: 'Bekreft',
      resetFilter: 'Tilbakestill',
      clearFilter: 'Alle',
    },
    tree: {
      emptyText: 'Ingen data',
    },
  },

  creditNoteWarning: {
    invoiceInfo: {
      exciseInventoryActivated:
        'Du har særavgift og lagermodul aktivert på din konto. Husk å fullføre kreditnotaen for å registrere evt. returer!',
      specialChargeActivated:
        'Du har særavgift aktivert på din konto. Husk å fullføre kreditnotaen for å registrere evt. returer!',
      storageModuleEnabled:
        'Du har lagermodul aktivert på din konto. Husk å fullføre kreditnotaen for å registrere evt. returer!',
      noClientEmail:
        'Kunden mangler epost. Kreditnota kan ikke sendes på epost før adressen er lagt til kunden.',
    },
  },

  warnings: {
    billReminder: {
      unableToCreateWithFee: 'Kan ikke opprette påminnelse med gebyrer pga. følgende:',
      reasons: {
        max2: 'Maks antall purringer med gebyrer (2 stk) er alt opprettet.',
        notDue: 'Påminnelse med gebyr kan ikke opprettes før 14 dager etter forfallsdato.',
        oneReminderFee: 'Forrige påminnelse pågår. Vennligst vent',
        oneReminderFeeDays: 'dager før du sender ny.',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/locale/no/index.js